import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";

import { Link } from "react-router-dom";

import axios from "axios";

import {

    Trophy,

    Calendar,

    Send,

    Plus,

    Clock,

    ChevronRight,

    ChevronLeft,

    Sparkles,

    Bot,

    User,

    Users,

    CheckCircle,

    RefreshCw,

    Info,

    X,

    Play

} from "lucide-react";

import { Breadcrumbs } from "../components/Breadcrumbs";

import { SEO, breadcrumbSchema, sportsEventSchema } from "../components/SEO";



// World Cup simulator imports

import { useSimulation } from "../hooks/useSimulation";

import { SimulationControls } from "../components/sim/SimulationControls";

import { ChampionProbBar } from "../components/sim/ChampionProbBar";

import { StageMatrix } from "../components/sim/StageMatrix";

import { PredictionDelta } from "../components/sim/PredictionDelta";

import { BracketTree } from "../components/sim/BracketTree";

import { ValueBetsFinder } from "../components/sim/ValueBetsFinder";

import confetti from "canvas-confetti";



// Individual Match Simulator engine imports

import { TEAMS } from "../lib/sim/engine";

import { sampleScore, effectiveElo, recentFormAdjustment, absenceAdjustment } from "../lib/sim/match";

import { XoshiroRNG } from "../lib/sim/rng";

import { shootoutWinProb } from "../lib/sim/penalties";

import { samplePoisson } from "../lib/sim/goals";





const STAGES = [

    { id: "groups", label: "Phase de groupes" },

    { id: "32es", label: "16es de finale" },

    { id: "8es", label: "8es de finale" },

    { id: "quarters", label: "Quarts de finale" },

    { id: "semis", label: "Demi-finales" },

    { id: "final", label: "Finale" },

];



const DATES_BY_STAGE = {

    groups: ["06/11", "06/12", "06/13", "06/14", "06/15", "06/16", "06/17", "06/18", "06/19", "06/20", "06/21", "06/22", "06/23", "06/24", "06/25", "06/26", "06/27", "06/28"],

    "32es": ["06/28", "06/29", "06/30", "07/01", "07/02", "07/03", "07/04"],

    "8es": ["07/04", "07/05", "07/06", "07/07"],

    quarters: ["07/09", "07/10", "07/11", "07/12"],

    semis: ["07/14", "07/15"],

    final: ["07/18", "07/19"],

};



const MATCHES = [

    {

        id: "mex-rsa",

        stage: "groups",

        date: "06/11",

        time: "21:00",

        group: "Groupe A - 1re j.",

        teamA: { name: "Mexique", code: "MEX", flag: "https://flagcdn.com/w80/mx.png" },

        teamB: { name: "Afrique du Sud", code: "RSA", flag: "https://flagcdn.com/w80/za.png" },

        status: "À venir",

        kickoff: "2026-06-11T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Mexique vs. Afrique du Sud.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe A - 1re j..\n\n**Forces de Mexique** : Discipline de bloc, transition rapide.\n**Forces de Afrique du Sud** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "kor-cze",

        stage: "groups",

        date: "06/12",

        time: "04:00",

        group: "Groupe A - 1re j.",

        teamA: { name: "Corée du Sud", code: "KOR", flag: "https://flagcdn.com/w80/kr.png" },

        teamB: { name: "Rép. tchèque", code: "CZE", flag: "https://flagcdn.com/w80/cz.png" },

        status: "À venir",

        kickoff: "2026-06-12T04:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Corée du Sud vs. Rép. tchèque.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe A - 1re j..\n\n**Forces de Corée du Sud** : Discipline de bloc, transition rapide.\n**Forces de Rép. tchèque** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "can-bih",

        stage: "groups",

        date: "06/12",

        time: "21:00",

        group: "Groupe B - 1re j.",

        teamA: { name: "Canada", code: "CAN", flag: "https://flagcdn.com/w80/ca.png" },

        teamB: { name: "Bosnie-Herzégovine", code: "BIH", flag: "https://flagcdn.com/w80/ba.png" },

        status: "À venir",

        kickoff: "2026-06-12T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Canada vs. Bosnie-Herzégovine.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe B - 1re j..\n\n**Forces de Canada** : Discipline de bloc, transition rapide.\n**Forces de Bosnie-Herzégovine** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "qat-sui",

        stage: "groups",

        date: "06/13",

        time: "21:00",

        group: "Groupe B - 1re j.",

        teamA: { name: "Qatar", code: "QAT", flag: "https://flagcdn.com/w80/qa.png" },

        teamB: { name: "Suisse", code: "SUI", flag: "https://flagcdn.com/w80/ch.png" },

        status: "À venir",

        kickoff: "2026-06-13T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Qatar vs. Suisse.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe B - 1re j..\n\n**Forces de Qatar** : Discipline de bloc, transition rapide.\n**Forces de Suisse** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "usa-par",

        stage: "groups",

        date: "06/13",

        time: "03:00",

        group: "Groupe D - 1re j.",

        teamA: { name: "États-Unis", code: "USA", flag: "https://flagcdn.com/w80/us.png" },

        teamB: { name: "Paraguay", code: "PAR", flag: "https://flagcdn.com/w80/py.png" },

        status: "À venir",

        kickoff: "2026-06-13T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match États-Unis vs. Paraguay.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe D - 1re j..\n\n**Forces de États-Unis** : Discipline de bloc, transition rapide.\n**Forces de Paraguay** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "bra-mar",

        stage: "groups",

        date: "06/14",

        time: "00:00",

        group: "Groupe C - 1re j.",

        teamA: { name: "Brésil", code: "BRA", flag: "https://flagcdn.com/w80/br.png" },

        teamB: { name: "Maroc", code: "MAR", flag: "https://flagcdn.com/w80/ma.png" },

        status: "À venir",

        kickoff: "2026-06-14T00:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Brésil vs. Maroc.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe C - 1re j..\n\n**Forces de Brésil** : Discipline de bloc, transition rapide.\n**Forces de Maroc** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "hai-sco",

        stage: "groups",

        date: "06/14",

        time: "03:00",

        group: "Groupe C - 1re j.",

        teamA: { name: "Haïti", code: "HAI", flag: "https://flagcdn.com/w80/ht.png" },

        teamB: { name: "Écosse", code: "SCO", flag: "https://flagcdn.com/w80/gb-sct.png" },

        status: "À venir",

        kickoff: "2026-06-14T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Haïti vs. Écosse.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe C - 1re j..\n\n**Forces de Haïti** : Discipline de bloc, transition rapide.\n**Forces de Écosse** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "aus-tur",

        stage: "groups",

        date: "06/14",

        time: "06:00",

        group: "Groupe D - 1re j.",

        teamA: { name: "Australie", code: "AUS", flag: "https://flagcdn.com/w80/au.png" },

        teamB: { name: "Turquie", code: "TUR", flag: "https://flagcdn.com/w80/tr.png" },

        status: "À venir",

        kickoff: "2026-06-14T06:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Australie vs. Turquie.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe D - 1re j..\n\n**Forces de Australie** : Discipline de bloc, transition rapide.\n**Forces de Turquie** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "ger-cuw",

        stage: "groups",

        date: "06/14",

        time: "19:00",

        group: "Groupe E - 1re j.",

        teamA: { name: "Allemagne", code: "GER", flag: "https://flagcdn.com/w80/de.png" },

        teamB: { name: "Curaçao", code: "CUW", flag: "https://flagcdn.com/w80/cw.png" },

        status: "À venir",

        kickoff: "2026-06-14T19:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Allemagne vs. Curaçao.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe E - 1re j..\n\n**Forces de Allemagne** : Discipline de bloc, transition rapide.\n**Forces de Curaçao** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "ned-jpn",

        stage: "groups",

        date: "06/14",

        time: "22:00",

        group: "Groupe F - 1re j.",

        teamA: { name: "Pays-Bas", code: "NED", flag: "https://flagcdn.com/w80/nl.png" },

        teamB: { name: "Japon", code: "JPN", flag: "https://flagcdn.com/w80/jp.png" },

        status: "À venir",

        kickoff: "2026-06-14T22:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Pays-Bas vs. Japon.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe F - 1re j..\n\n**Forces de Pays-Bas** : Discipline de bloc, transition rapide.\n**Forces de Japon** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "civ-ecu",

        stage: "groups",

        date: "06/15",

        time: "01:00",

        group: "Groupe E - 1re j.",

        teamA: { name: "Côte d'Ivoire", code: "CIV", flag: "https://flagcdn.com/w80/ci.png" },

        teamB: { name: "Equateur", code: "ECU", flag: "https://flagcdn.com/w80/ec.png" },

        status: "À venir",

        kickoff: "2026-06-15T01:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Côte d'Ivoire vs. Equateur.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe E - 1re j..\n\n**Forces de Côte d'Ivoire** : Discipline de bloc, transition rapide.\n**Forces de Equateur** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "swe-tun",

        stage: "groups",

        date: "06/15",

        time: "04:00",

        group: "Groupe F - 1re j.",

        teamA: { name: "Suède", code: "SWE", flag: "https://flagcdn.com/w80/se.png" },

        teamB: { name: "Tunisie", code: "TUN", flag: "https://flagcdn.com/w80/tn.png" },

        status: "À venir",

        kickoff: "2026-06-15T04:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Suède vs. Tunisie.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe F - 1re j..\n\n**Forces de Suède** : Discipline de bloc, transition rapide.\n**Forces de Tunisie** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "bel-egy",

        stage: "groups",

        date: "06/15",

        time: "21:00",

        group: "Groupe G - 1re j.",

        teamA: { name: "Belgique", code: "BEL", flag: "https://flagcdn.com/w80/be.png" },

        teamB: { name: "Égypte", code: "EGY", flag: "https://flagcdn.com/w80/eg.png" },

        status: "À venir",

        kickoff: "2026-06-15T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Belgique vs. Égypte.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe G - 1re j..\n\n**Forces de Belgique** : Discipline de bloc, transition rapide.\n**Forces de Égypte** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "esp-cpv",

        stage: "groups",

        date: "06/15",

        time: "18:00",

        group: "Groupe H - 1re j.",

        teamA: { name: "Espagne", code: "ESP", flag: "https://flagcdn.com/w80/es.png" },

        teamB: { name: "Cap-Vert", code: "CPV", flag: "https://flagcdn.com/w80/cv.png" },

        status: "À venir",

        kickoff: "2026-06-15T18:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Espagne vs. Cap-Vert.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe H - 1re j..\n\n**Forces de Espagne** : Discipline de bloc, transition rapide.\n**Forces de Cap-Vert** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "irn-nzl",

        stage: "groups",

        date: "06/16",

        time: "03:00",

        group: "Groupe G - 1re j.",

        teamA: { name: "Iran", code: "IRN", flag: "https://flagcdn.com/w80/ir.png" },

        teamB: { name: "Nouvelle-Zélande", code: "NZL", flag: "https://flagcdn.com/w80/nz.png" },

        status: "À venir",

        kickoff: "2026-06-16T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Iran vs. Nouvelle-Zélande.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe G - 1re j..\n\n**Forces de Iran** : Discipline de bloc, transition rapide.\n**Forces de Nouvelle-Zélande** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "ksa-uru",

        stage: "groups",

        date: "06/16",

        time: "00:00",

        group: "Groupe H - 1re j.",

        teamA: { name: "Arabie saoudite", code: "KSA", flag: "https://flagcdn.com/w80/sa.png" },

        teamB: { name: "Uruguay", code: "URU", flag: "https://flagcdn.com/w80/uy.png" },

        status: "À venir",

        kickoff: "2026-06-16T00:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Arabie saoudite vs. Uruguay.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe H - 1re j..\n\n**Forces de Arabie saoudite** : Discipline de bloc, transition rapide.\n**Forces de Uruguay** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "fra-sen",

        stage: "groups",

        date: "06/16",

        time: "21:00",

        group: "Groupe I - 1re j.",

        teamA: { name: "France", code: "FRA", flag: "https://flagcdn.com/w80/fr.png" },

        teamB: { name: "Sénégal", code: "SEN", flag: "https://flagcdn.com/w80/sn.png" },

        status: "À venir",

        kickoff: "2026-06-16T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match France vs. Sénégal.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe I - 1re j..\n\n**Forces de France** : Discipline de bloc, transition rapide.\n**Forces de Sénégal** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "irq-nor",

        stage: "groups",

        date: "06/17",

        time: "00:00",

        group: "Groupe I - 1re j.",

        teamA: { name: "Irak", code: "IRQ", flag: "https://flagcdn.com/w80/iq.png" },

        teamB: { name: "Norvège", code: "NOR", flag: "https://flagcdn.com/w80/no.png" },

        status: "À venir",

        kickoff: "2026-06-17T00:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Irak vs. Norvège.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe I - 1re j..\n\n**Forces de Irak** : Discipline de bloc, transition rapide.\n**Forces de Norvège** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "arg-alg",

        stage: "groups",

        date: "06/17",

        time: "03:00",

        group: "Groupe J - 1re j.",

        teamA: { name: "Argentine", code: "ARG", flag: "https://flagcdn.com/w80/ar.png" },

        teamB: { name: "Algérie", code: "ALG", flag: "https://flagcdn.com/w80/dz.png" },

        status: "À venir",

        kickoff: "2026-06-17T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Argentine vs. Algérie.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe J - 1re j..\n\n**Forces de Argentine** : Discipline de bloc, transition rapide.\n**Forces de Algérie** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "aut-jor",

        stage: "groups",

        date: "06/17",

        time: "06:00",

        group: "Groupe J - 1re j.",

        teamA: { name: "Autriche", code: "AUT", flag: "https://flagcdn.com/w80/at.png" },

        teamB: { name: "Jordanie", code: "JOR", flag: "https://flagcdn.com/w80/jo.png" },

        status: "À venir",

        kickoff: "2026-06-17T06:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Autriche vs. Jordanie.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe J - 1re j..\n\n**Forces de Autriche** : Discipline de bloc, transition rapide.\n**Forces de Jordanie** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "por-cod",

        stage: "groups",

        date: "06/17",

        time: "19:00",

        group: "Groupe K - 1re j.",

        teamA: { name: "Portugal", code: "POR", flag: "https://flagcdn.com/w80/pt.png" },

        teamB: { name: "RD Congo", code: "COD", flag: "https://flagcdn.com/w80/cd.png" },

        status: "À venir",

        kickoff: "2026-06-17T19:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Portugal vs. RD Congo.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe K - 1re j..\n\n**Forces de Portugal** : Discipline de bloc, transition rapide.\n**Forces de RD Congo** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "eng-cro",

        stage: "groups",

        date: "06/17",

        time: "22:00",

        group: "Groupe L - 1re j.",

        teamA: { name: "Angleterre", code: "ENG", flag: "https://flagcdn.com/w80/gb.png" },

        teamB: { name: "Croatie", code: "CRO", flag: "https://flagcdn.com/w80/hr.png" },

        status: "À venir",

        kickoff: "2026-06-17T22:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Angleterre vs. Croatie.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe L - 1re j..\n\n**Forces de Angleterre** : Discipline de bloc, transition rapide.\n**Forces de Croatie** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "cze-rsa",

        stage: "groups",

        date: "06/18",

        time: "18:00",

        group: "Groupe A - 2e j.",

        teamA: { name: "Rép. tchèque", code: "CZE", flag: "https://flagcdn.com/w80/cz.png" },

        teamB: { name: "Afrique du Sud", code: "RSA", flag: "https://flagcdn.com/w80/za.png" },

        status: "À venir",

        kickoff: "2026-06-18T18:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Rép. tchèque vs. Afrique du Sud.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe A - 2e j..\n\n**Forces de Rép. tchèque** : Discipline de bloc, transition rapide.\n**Forces de Afrique du Sud** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "sui-bih",

        stage: "groups",

        date: "06/18",

        time: "21:00",

        group: "Groupe B - 2e j.",

        teamA: { name: "Suisse", code: "SUI", flag: "https://flagcdn.com/w80/ch.png" },

        teamB: { name: "Bosnie-Herzégovine", code: "BIH", flag: "https://flagcdn.com/w80/ba.png" },

        status: "À venir",

        kickoff: "2026-06-18T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Suisse vs. Bosnie-Herzégovine.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe B - 2e j..\n\n**Forces de Suisse** : Discipline de bloc, transition rapide.\n**Forces de Bosnie-Herzégovine** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "uzb-col",

        stage: "groups",

        date: "06/18",

        time: "04:00",

        group: "Groupe K - 1re j.",

        teamA: { name: "Ouzbékistan", code: "UZB", flag: "https://flagcdn.com/w80/uz.png" },

        teamB: { name: "Colombie", code: "COL", flag: "https://flagcdn.com/w80/co.png" },

        status: "À venir",

        kickoff: "2026-06-18T04:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Ouzbékistan vs. Colombie.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe K - 1re j..\n\n**Forces de Ouzbékistan** : Discipline de bloc, transition rapide.\n**Forces de Colombie** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "gha-pan",

        stage: "groups",

        date: "06/18",

        time: "01:00",

        group: "Groupe L - 1re j.",

        teamA: { name: "Ghana", code: "GHA", flag: "https://flagcdn.com/w80/gh.png" },

        teamB: { name: "Panama", code: "PAN", flag: "https://flagcdn.com/w80/pa.png" },

        status: "À venir",

        kickoff: "2026-06-18T01:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Ghana vs. Panama.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe L - 1re j..\n\n**Forces de Ghana** : Discipline de bloc, transition rapide.\n**Forces de Panama** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "mex-kor",

        stage: "groups",

        date: "06/19",

        time: "03:00",

        group: "Groupe A - 2e j.",

        teamA: { name: "Mexique", code: "MEX", flag: "https://flagcdn.com/w80/mx.png" },

        teamB: { name: "Corée du Sud", code: "KOR", flag: "https://flagcdn.com/w80/kr.png" },

        status: "À venir",

        kickoff: "2026-06-19T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Mexique vs. Corée du Sud.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe A - 2e j..\n\n**Forces de Mexique** : Discipline de bloc, transition rapide.\n**Forces de Corée du Sud** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "can-qat",

        stage: "groups",

        date: "06/19",

        time: "00:00",

        group: "Groupe B - 2e j.",

        teamA: { name: "Canada", code: "CAN", flag: "https://flagcdn.com/w80/ca.png" },

        teamB: { name: "Qatar", code: "QAT", flag: "https://flagcdn.com/w80/qa.png" },

        status: "À venir",

        kickoff: "2026-06-19T00:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Canada vs. Qatar.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe B - 2e j..\n\n**Forces de Canada** : Discipline de bloc, transition rapide.\n**Forces de Qatar** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "usa-aus",

        stage: "groups",

        date: "06/19",

        time: "21:00",

        group: "Groupe D - 2e j.",

        teamA: { name: "États-Unis", code: "USA", flag: "https://flagcdn.com/w80/us.png" },

        teamB: { name: "Australie", code: "AUS", flag: "https://flagcdn.com/w80/au.png" },

        status: "À venir",

        kickoff: "2026-06-19T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match États-Unis vs. Australie.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe D - 2e j..\n\n**Forces de États-Unis** : Discipline de bloc, transition rapide.\n**Forces de Australie** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "sco-mar",

        stage: "groups",

        date: "06/20",

        time: "00:00",

        group: "Groupe C - 2e j.",

        teamA: { name: "Écosse", code: "SCO", flag: "https://flagcdn.com/w80/gb-sct.png" },

        teamB: { name: "Maroc", code: "MAR", flag: "https://flagcdn.com/w80/ma.png" },

        status: "À venir",

        kickoff: "2026-06-20T00:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Écosse vs. Maroc.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe C - 2e j..\n\n**Forces de Écosse** : Discipline de bloc, transition rapide.\n**Forces de Maroc** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "bra-hai",

        stage: "groups",

        date: "06/20",

        time: "03:00",

        group: "Groupe C - 2e j.",

        teamA: { name: "Brésil", code: "BRA", flag: "https://flagcdn.com/w80/br.png" },

        teamB: { name: "Haïti", code: "HAI", flag: "https://flagcdn.com/w80/ht.png" },

        status: "À venir",

        kickoff: "2026-06-20T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Brésil vs. Haïti.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe C - 2e j..\n\n**Forces de Brésil** : Discipline de bloc, transition rapide.\n**Forces de Haïti** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "tur-par",

        stage: "groups",

        date: "06/20",

        time: "06:00",

        group: "Groupe D - 2e j.",

        teamA: { name: "Turquie", code: "TUR", flag: "https://flagcdn.com/w80/tr.png" },

        teamB: { name: "Paraguay", code: "PAR", flag: "https://flagcdn.com/w80/py.png" },

        status: "À venir",

        kickoff: "2026-06-20T06:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Turquie vs. Paraguay.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe D - 2e j..\n\n**Forces de Turquie** : Discipline de bloc, transition rapide.\n**Forces de Paraguay** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "ger-civ",

        stage: "groups",

        date: "06/20",

        time: "22:00",

        group: "Groupe E - 2e j.",

        teamA: { name: "Allemagne", code: "GER", flag: "https://flagcdn.com/w80/de.png" },

        teamB: { name: "Côte d'Ivoire", code: "CIV", flag: "https://flagcdn.com/w80/ci.png" },

        status: "À venir",

        kickoff: "2026-06-20T22:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Allemagne vs. Côte d'Ivoire.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe E - 2e j..\n\n**Forces de Allemagne** : Discipline de bloc, transition rapide.\n**Forces de Côte d'Ivoire** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "ned-swe",

        stage: "groups",

        date: "06/20",

        time: "19:00",

        group: "Groupe F - 2e j.",

        teamA: { name: "Pays-Bas", code: "NED", flag: "https://flagcdn.com/w80/nl.png" },

        teamB: { name: "Suède", code: "SWE", flag: "https://flagcdn.com/w80/se.png" },

        status: "À venir",

        kickoff: "2026-06-20T19:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Pays-Bas vs. Suède.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe F - 2e j..\n\n**Forces de Pays-Bas** : Discipline de bloc, transition rapide.\n**Forces de Suède** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "ecu-cuw",

        stage: "groups",

        date: "06/21",

        time: "02:00",

        group: "Groupe E - 2e j.",

        teamA: { name: "Equateur", code: "ECU", flag: "https://flagcdn.com/w80/ec.png" },

        teamB: { name: "Curaçao", code: "CUW", flag: "https://flagcdn.com/w80/cw.png" },

        status: "À venir",

        kickoff: "2026-06-21T02:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Equateur vs. Curaçao.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe E - 2e j..\n\n**Forces de Equateur** : Discipline de bloc, transition rapide.\n**Forces de Curaçao** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "tun-jpn",

        stage: "groups",

        date: "06/21",

        time: "06:00",

        group: "Groupe F - 2e j.",

        teamA: { name: "Tunisie", code: "TUN", flag: "https://flagcdn.com/w80/tn.png" },

        teamB: { name: "Japon", code: "JPN", flag: "https://flagcdn.com/w80/jp.png" },

        status: "À venir",

        kickoff: "2026-06-21T06:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Tunisie vs. Japon.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe F - 2e j..\n\n**Forces de Tunisie** : Discipline de bloc, transition rapide.\n**Forces de Japon** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "bel-irn",

        stage: "groups",

        date: "06/21",

        time: "21:00",

        group: "Groupe G - 2e j.",

        teamA: { name: "Belgique", code: "BEL", flag: "https://flagcdn.com/w80/be.png" },

        teamB: { name: "Iran", code: "IRN", flag: "https://flagcdn.com/w80/ir.png" },

        status: "À venir",

        kickoff: "2026-06-21T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Belgique vs. Iran.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe G - 2e j..\n\n**Forces de Belgique** : Discipline de bloc, transition rapide.\n**Forces de Iran** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "esp-ksa",

        stage: "groups",

        date: "06/21",

        time: "18:00",

        group: "Groupe H - 2e j.",

        teamA: { name: "Espagne", code: "ESP", flag: "https://flagcdn.com/w80/es.png" },

        teamB: { name: "Arabie saoudite", code: "KSA", flag: "https://flagcdn.com/w80/sa.png" },

        status: "À venir",

        kickoff: "2026-06-21T18:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Espagne vs. Arabie saoudite.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe H - 2e j..\n\n**Forces de Espagne** : Discipline de bloc, transition rapide.\n**Forces de Arabie saoudite** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "nzl-egy",

        stage: "groups",

        date: "06/22",

        time: "03:00",

        group: "Groupe G - 2e j.",

        teamA: { name: "Nouvelle-Zélande", code: "NZL", flag: "https://flagcdn.com/w80/nz.png" },

        teamB: { name: "Égypte", code: "EGY", flag: "https://flagcdn.com/w80/eg.png" },

        status: "À venir",

        kickoff: "2026-06-22T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Nouvelle-Zélande vs. Égypte.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe G - 2e j..\n\n**Forces de Nouvelle-Zélande** : Discipline de bloc, transition rapide.\n**Forces de Égypte** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "uru-cpv",

        stage: "groups",

        date: "06/22",

        time: "00:00",

        group: "Groupe H - 2e j.",

        teamA: { name: "Uruguay", code: "URU", flag: "https://flagcdn.com/w80/uy.png" },

        teamB: { name: "Cap-Vert", code: "CPV", flag: "https://flagcdn.com/w80/cv.png" },

        status: "À venir",

        kickoff: "2026-06-22T00:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Uruguay vs. Cap-Vert.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe H - 2e j..\n\n**Forces de Uruguay** : Discipline de bloc, transition rapide.\n**Forces de Cap-Vert** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "fra-irq",

        stage: "groups",

        date: "06/22",

        time: "23:00",

        group: "Groupe I - 2e j.",

        teamA: { name: "France", code: "FRA", flag: "https://flagcdn.com/w80/fr.png" },

        teamB: { name: "Irak", code: "IRQ", flag: "https://flagcdn.com/w80/iq.png" },

        status: "À venir",

        kickoff: "2026-06-22T23:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match France vs. Irak.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe I - 2e j..\n\n**Forces de France** : Discipline de bloc, transition rapide.\n**Forces de Irak** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "arg-aut",

        stage: "groups",

        date: "06/22",

        time: "19:00",

        group: "Groupe J - 2e j.",

        teamA: { name: "Argentine", code: "ARG", flag: "https://flagcdn.com/w80/ar.png" },

        teamB: { name: "Autriche", code: "AUT", flag: "https://flagcdn.com/w80/at.png" },

        status: "À venir",

        kickoff: "2026-06-22T19:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Argentine vs. Autriche.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe J - 2e j..\n\n**Forces de Argentine** : Discipline de bloc, transition rapide.\n**Forces de Autriche** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "nor-sen",

        stage: "groups",

        date: "06/23",

        time: "02:00",

        group: "Groupe I - 2e j.",

        teamA: { name: "Norvège", code: "NOR", flag: "https://flagcdn.com/w80/no.png" },

        teamB: { name: "Sénégal", code: "SEN", flag: "https://flagcdn.com/w80/sn.png" },

        status: "À venir",

        kickoff: "2026-06-23T02:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Norvège vs. Sénégal.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe I - 2e j..\n\n**Forces de Norvège** : Discipline de bloc, transition rapide.\n**Forces de Sénégal** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "jor-alg",

        stage: "groups",

        date: "06/23",

        time: "05:00",

        group: "Groupe J - 2e j.",

        teamA: { name: "Jordanie", code: "JOR", flag: "https://flagcdn.com/w80/jo.png" },

        teamB: { name: "Algérie", code: "ALG", flag: "https://flagcdn.com/w80/dz.png" },

        status: "À venir",

        kickoff: "2026-06-23T05:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Jordanie vs. Algérie.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe J - 2e j..\n\n**Forces de Jordanie** : Discipline de bloc, transition rapide.\n**Forces de Algérie** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "por-uzb",

        stage: "groups",

        date: "06/23",

        time: "19:00",

        group: "Groupe K - 2e j.",

        teamA: { name: "Portugal", code: "POR", flag: "https://flagcdn.com/w80/pt.png" },

        teamB: { name: "Ouzbékistan", code: "UZB", flag: "https://flagcdn.com/w80/uz.png" },

        status: "À venir",

        kickoff: "2026-06-23T19:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Portugal vs. Ouzbékistan.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe K - 2e j..\n\n**Forces de Portugal** : Discipline de bloc, transition rapide.\n**Forces de Ouzbékistan** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "eng-gha",

        stage: "groups",

        date: "06/23",

        time: "22:00",

        group: "Groupe L - 2e j.",

        teamA: { name: "Angleterre", code: "ENG", flag: "https://flagcdn.com/w80/gb.png" },

        teamB: { name: "Ghana", code: "GHA", flag: "https://flagcdn.com/w80/gh.png" },

        status: "À venir",

        kickoff: "2026-06-23T22:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Angleterre vs. Ghana.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe L - 2e j..\n\n**Forces de Angleterre** : Discipline de bloc, transition rapide.\n**Forces de Ghana** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "sui-can",

        stage: "groups",

        date: "06/24",

        time: "21:00",

        group: "Groupe B - 3e j.",

        teamA: { name: "Suisse", code: "SUI", flag: "https://flagcdn.com/w80/ch.png" },

        teamB: { name: "Canada", code: "CAN", flag: "https://flagcdn.com/w80/ca.png" },

        status: "À venir",

        kickoff: "2026-06-24T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Suisse vs. Canada.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe B - 3e j..\n\n**Forces de Suisse** : Discipline de bloc, transition rapide.\n**Forces de Canada** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "bih-qat",

        stage: "groups",

        date: "06/24",

        time: "21:00",

        group: "Groupe B - 3e j.",

        teamA: { name: "Bosnie-Herzégovine", code: "BIH", flag: "https://flagcdn.com/w80/ba.png" },

        teamB: { name: "Qatar", code: "QAT", flag: "https://flagcdn.com/w80/qa.png" },

        status: "À venir",

        kickoff: "2026-06-24T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Bosnie-Herzégovine vs. Qatar.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe B - 3e j..\n\n**Forces de Bosnie-Herzégovine** : Discipline de bloc, transition rapide.\n**Forces de Qatar** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "col-cod",

        stage: "groups",

        date: "06/24",

        time: "04:00",

        group: "Groupe K - 2e j.",

        teamA: { name: "Colombie", code: "COL", flag: "https://flagcdn.com/w80/co.png" },

        teamB: { name: "RD Congo", code: "COD", flag: "https://flagcdn.com/w80/cd.png" },

        status: "À venir",

        kickoff: "2026-06-24T04:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Colombie vs. RD Congo.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe K - 2e j..\n\n**Forces de Colombie** : Discipline de bloc, transition rapide.\n**Forces de RD Congo** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "pan-cro",

        stage: "groups",

        date: "06/24",

        time: "01:00",

        group: "Groupe L - 2e j.",

        teamA: { name: "Panama", code: "PAN", flag: "https://flagcdn.com/w80/pa.png" },

        teamB: { name: "Croatie", code: "CRO", flag: "https://flagcdn.com/w80/hr.png" },

        status: "À venir",

        kickoff: "2026-06-24T01:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Panama vs. Croatie.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe L - 2e j..\n\n**Forces de Panama** : Discipline de bloc, transition rapide.\n**Forces de Croatie** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "rsa-kor",

        stage: "groups",

        date: "06/25",

        time: "03:00",

        group: "Groupe A - 3e j.",

        teamA: { name: "Afrique du Sud", code: "RSA", flag: "https://flagcdn.com/w80/za.png" },

        teamB: { name: "Corée du Sud", code: "KOR", flag: "https://flagcdn.com/w80/kr.png" },

        status: "À venir",

        kickoff: "2026-06-25T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Afrique du Sud vs. Corée du Sud.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe A - 3e j..\n\n**Forces de Afrique du Sud** : Discipline de bloc, transition rapide.\n**Forces de Corée du Sud** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "cze-mex",

        stage: "groups",

        date: "06/25",

        time: "03:00",

        group: "Groupe A - 3e j.",

        teamA: { name: "Rép. tchèque", code: "CZE", flag: "https://flagcdn.com/w80/cz.png" },

        teamB: { name: "Mexique", code: "MEX", flag: "https://flagcdn.com/w80/mx.png" },

        status: "À venir",

        kickoff: "2026-06-25T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Rép. tchèque vs. Mexique.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe A - 3e j..\n\n**Forces de Rép. tchèque** : Discipline de bloc, transition rapide.\n**Forces de Mexique** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "sco-bra",

        stage: "groups",

        date: "06/25",

        time: "00:00",

        group: "Groupe C - 3e j.",

        teamA: { name: "Écosse", code: "SCO", flag: "https://flagcdn.com/w80/gb-sct.png" },

        teamB: { name: "Brésil", code: "BRA", flag: "https://flagcdn.com/w80/br.png" },

        status: "À venir",

        kickoff: "2026-06-25T00:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Écosse vs. Brésil.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe C - 3e j..\n\n**Forces de Écosse** : Discipline de bloc, transition rapide.\n**Forces de Brésil** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "mar-hai",

        stage: "groups",

        date: "06/25",

        time: "00:00",

        group: "Groupe C - 3e j.",

        teamA: { name: "Maroc", code: "MAR", flag: "https://flagcdn.com/w80/ma.png" },

        teamB: { name: "Haïti", code: "HAI", flag: "https://flagcdn.com/w80/ht.png" },

        status: "À venir",

        kickoff: "2026-06-25T00:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Maroc vs. Haïti.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe C - 3e j..\n\n**Forces de Maroc** : Discipline de bloc, transition rapide.\n**Forces de Haïti** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "cuw-civ",

        stage: "groups",

        date: "06/25",

        time: "22:00",

        group: "Groupe E - 3e j.",

        teamA: { name: "Curaçao", code: "CUW", flag: "https://flagcdn.com/w80/cw.png" },

        teamB: { name: "Côte d'Ivoire", code: "CIV", flag: "https://flagcdn.com/w80/ci.png" },

        status: "À venir",

        kickoff: "2026-06-25T22:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Curaçao vs. Côte d'Ivoire.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe E - 3e j..\n\n**Forces de Curaçao** : Discipline de bloc, transition rapide.\n**Forces de Côte d'Ivoire** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "ecu-ger",

        stage: "groups",

        date: "06/25",

        time: "22:00",

        group: "Groupe E - 3e j.",

        teamA: { name: "Equateur", code: "ECU", flag: "https://flagcdn.com/w80/ec.png" },

        teamB: { name: "Allemagne", code: "GER", flag: "https://flagcdn.com/w80/de.png" },

        status: "À venir",

        kickoff: "2026-06-25T22:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Equateur vs. Allemagne.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe E - 3e j..\n\n**Forces de Equateur** : Discipline de bloc, transition rapide.\n**Forces de Allemagne** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "par-aus",

        stage: "groups",

        date: "06/26",

        time: "04:00",

        group: "Groupe D - 3e j.",

        teamA: { name: "Paraguay", code: "PAR", flag: "https://flagcdn.com/w80/py.png" },

        teamB: { name: "Australie", code: "AUS", flag: "https://flagcdn.com/w80/au.png" },

        status: "À venir",

        kickoff: "2026-06-26T04:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Paraguay vs. Australie.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe D - 3e j..\n\n**Forces de Paraguay** : Discipline de bloc, transition rapide.\n**Forces de Australie** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "tur-usa",

        stage: "groups",

        date: "06/26",

        time: "04:00",

        group: "Groupe D - 3e j.",

        teamA: { name: "Turquie", code: "TUR", flag: "https://flagcdn.com/w80/tr.png" },

        teamB: { name: "États-Unis", code: "USA", flag: "https://flagcdn.com/w80/us.png" },

        status: "À venir",

        kickoff: "2026-06-26T04:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Turquie vs. États-Unis.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe D - 3e j..\n\n**Forces de Turquie** : Discipline de bloc, transition rapide.\n**Forces de États-Unis** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "jpn-swe",

        stage: "groups",

        date: "06/26",

        time: "01:00",

        group: "Groupe F - 3e j.",

        teamA: { name: "Japon", code: "JPN", flag: "https://flagcdn.com/w80/jp.png" },

        teamB: { name: "Suède", code: "SWE", flag: "https://flagcdn.com/w80/se.png" },

        status: "À venir",

        kickoff: "2026-06-26T01:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Japon vs. Suède.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe F - 3e j..\n\n**Forces de Japon** : Discipline de bloc, transition rapide.\n**Forces de Suède** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "tun-ned",

        stage: "groups",

        date: "06/26",

        time: "01:00",

        group: "Groupe F - 3e j.",

        teamA: { name: "Tunisie", code: "TUN", flag: "https://flagcdn.com/w80/tn.png" },

        teamB: { name: "Pays-Bas", code: "NED", flag: "https://flagcdn.com/w80/nl.png" },

        status: "À venir",

        kickoff: "2026-06-26T01:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Tunisie vs. Pays-Bas.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe F - 3e j..\n\n**Forces de Tunisie** : Discipline de bloc, transition rapide.\n**Forces de Pays-Bas** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "nor-fra",

        stage: "groups",

        date: "06/26",

        time: "21:00",

        group: "Groupe I - 3e j.",

        teamA: { name: "Norvège", code: "NOR", flag: "https://flagcdn.com/w80/no.png" },

        teamB: { name: "France", code: "FRA", flag: "https://flagcdn.com/w80/fr.png" },

        status: "À venir",

        kickoff: "2026-06-26T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Norvège vs. France.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe I - 3e j..\n\n**Forces de Norvège** : Discipline de bloc, transition rapide.\n**Forces de France** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "sen-irq",

        stage: "groups",

        date: "06/26",

        time: "21:00",

        group: "Groupe I - 3e j.",

        teamA: { name: "Sénégal", code: "SEN", flag: "https://flagcdn.com/w80/sn.png" },

        teamB: { name: "Irak", code: "IRQ", flag: "https://flagcdn.com/w80/iq.png" },

        status: "À venir",

        kickoff: "2026-06-26T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Sénégal vs. Irak.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe I - 3e j..\n\n**Forces de Sénégal** : Discipline de bloc, transition rapide.\n**Forces de Irak** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "nzl-bel",

        stage: "groups",

        date: "06/27",

        time: "05:00",

        group: "Groupe G - 3e j.",

        teamA: { name: "Nouvelle-Zélande", code: "NZL", flag: "https://flagcdn.com/w80/nz.png" },

        teamB: { name: "Belgique", code: "BEL", flag: "https://flagcdn.com/w80/be.png" },

        status: "À venir",

        kickoff: "2026-06-27T05:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Nouvelle-Zélande vs. Belgique.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe G - 3e j..\n\n**Forces de Nouvelle-Zélande** : Discipline de bloc, transition rapide.\n**Forces de Belgique** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "egy-irn",

        stage: "groups",

        date: "06/27",

        time: "05:00",

        group: "Groupe G - 3e j.",

        teamA: { name: "Égypte", code: "EGY", flag: "https://flagcdn.com/w80/eg.png" },

        teamB: { name: "Iran", code: "IRN", flag: "https://flagcdn.com/w80/ir.png" },

        status: "À venir",

        kickoff: "2026-06-27T05:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Égypte vs. Iran.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe G - 3e j..\n\n**Forces de Égypte** : Discipline de bloc, transition rapide.\n**Forces de Iran** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "uru-esp",

        stage: "groups",

        date: "06/27",

        time: "02:00",

        group: "Groupe H - 3e j.",

        teamA: { name: "Uruguay", code: "URU", flag: "https://flagcdn.com/w80/uy.png" },

        teamB: { name: "Espagne", code: "ESP", flag: "https://flagcdn.com/w80/es.png" },

        status: "À venir",

        kickoff: "2026-06-27T02:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Uruguay vs. Espagne.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe H - 3e j..\n\n**Forces de Uruguay** : Discipline de bloc, transition rapide.\n**Forces de Espagne** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "cpv-ksa",

        stage: "groups",

        date: "06/27",

        time: "02:00",

        group: "Groupe H - 3e j.",

        teamA: { name: "Cap-Vert", code: "CPV", flag: "https://flagcdn.com/w80/cv.png" },

        teamB: { name: "Arabie saoudite", code: "KSA", flag: "https://flagcdn.com/w80/sa.png" },

        status: "À venir",

        kickoff: "2026-06-27T02:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Cap-Vert vs. Arabie saoudite.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe H - 3e j..\n\n**Forces de Cap-Vert** : Discipline de bloc, transition rapide.\n**Forces de Arabie saoudite** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "pan-eng",

        stage: "groups",

        date: "06/27",

        time: "23:00",

        group: "Groupe L - 3e j.",

        teamA: { name: "Panama", code: "PAN", flag: "https://flagcdn.com/w80/pa.png" },

        teamB: { name: "Angleterre", code: "ENG", flag: "https://flagcdn.com/w80/gb.png" },

        status: "À venir",

        kickoff: "2026-06-27T23:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Panama vs. Angleterre.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe L - 3e j..\n\n**Forces de Panama** : Discipline de bloc, transition rapide.\n**Forces de Angleterre** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "cro-gha",

        stage: "groups",

        date: "06/27",

        time: "23:00",

        group: "Groupe L - 3e j.",

        teamA: { name: "Croatie", code: "CRO", flag: "https://flagcdn.com/w80/hr.png" },

        teamB: { name: "Ghana", code: "GHA", flag: "https://flagcdn.com/w80/gh.png" },

        status: "À venir",

        kickoff: "2026-06-27T23:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Croatie vs. Ghana.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe L - 3e j..\n\n**Forces de Croatie** : Discipline de bloc, transition rapide.\n**Forces de Ghana** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "jor-arg",

        stage: "groups",

        date: "06/28",

        time: "04:00",

        group: "Groupe J - 3e j.",

        teamA: { name: "Jordanie", code: "JOR", flag: "https://flagcdn.com/w80/jo.png" },

        teamB: { name: "Argentine", code: "ARG", flag: "https://flagcdn.com/w80/ar.png" },

        status: "À venir",

        kickoff: "2026-06-28T04:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Jordanie vs. Argentine.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe J - 3e j..\n\n**Forces de Jordanie** : Discipline de bloc, transition rapide.\n**Forces de Argentine** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "alg-aut",

        stage: "groups",

        date: "06/28",

        time: "04:00",

        group: "Groupe J - 3e j.",

        teamA: { name: "Algérie", code: "ALG", flag: "https://flagcdn.com/w80/dz.png" },

        teamB: { name: "Autriche", code: "AUT", flag: "https://flagcdn.com/w80/at.png" },

        status: "À venir",

        kickoff: "2026-06-28T04:00:00+02:00",

        aiAnalysis: "Analyse IA pour le match Algérie vs. Autriche.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe J - 3e j..\n\n**Forces de Algérie** : Discipline de bloc, transition rapide.\n**Forces de Autriche** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "cod-uzb",

        stage: "groups",

        date: "06/28",

        time: "01:30",

        group: "Groupe K - 3e j.",

        teamA: { name: "RD Congo", code: "COD", flag: "https://flagcdn.com/w80/cd.png" },

        teamB: { name: "Ouzbékistan", code: "UZB", flag: "https://flagcdn.com/w80/uz.png" },

        status: "À venir",

        kickoff: "2026-06-28T01:30:00+02:00",

        aiAnalysis: "Analyse IA pour le match RD Congo vs. Ouzbékistan.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe K - 3e j..\n\n**Forces de RD Congo** : Discipline de bloc, transition rapide.\n**Forces de Ouzbékistan** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "col-por",

        stage: "groups",

        date: "06/28",

        time: "01:30",

        group: "Groupe K - 3e j.",

        teamA: { name: "Colombie", code: "COL", flag: "https://flagcdn.com/w80/co.png" },

        teamB: { name: "Portugal", code: "POR", flag: "https://flagcdn.com/w80/pt.png" },

        status: "À venir",

        kickoff: "2026-06-28T01:30:00+02:00",

        aiAnalysis: "Analyse IA pour le match Colombie vs. Portugal.\n\nCe match s'annonce particulièrement serré dans le cadre du Groupe K - 3e j..\n\n**Forces de Colombie** : Discipline de bloc, transition rapide.\n**Forces de Portugal** : Capacité à dicter le rythme, impact physique.\n\n**Notre avis** : Double chance couvrant les deux issues possibles."

    },

    {

        id: "16e-1",

        stage: "32es",

        date: "06/28",

        time: "21:00",

        group: "16es de finale",

        teamA: { name: "2e Groupe A", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "2e Groupe B", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-06-28T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 2e Groupe A vs. 2e Groupe B.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-2",

        stage: "32es",

        date: "06/29",

        time: "19:00",

        group: "16es de finale",

        teamA: { name: "1er Groupe C", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "2e Groupe F", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-06-29T19:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe C vs. 2e Groupe F.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-3",

        stage: "32es",

        date: "06/29",

        time: "22:30",

        group: "16es de finale",

        teamA: { name: "1er Groupe E", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "3e Groupe A/B/C/D/F", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-06-29T22:30:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe E vs. 3e Groupe A/B/C/D/F.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-4",

        stage: "32es",

        date: "06/30",

        time: "03:00",

        group: "16es de finale",

        teamA: { name: "1er Groupe F", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "2e Groupe C", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-06-30T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe F vs. 2e Groupe C.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-5",

        stage: "32es",

        date: "06/30",

        time: "19:00",

        group: "16es de finale",

        teamA: { name: "2e Groupe E", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "2e Groupe I", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-06-30T19:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 2e Groupe E vs. 2e Groupe I.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-6",

        stage: "32es",

        date: "06/30",

        time: "23:00",

        group: "16es de finale",

        teamA: { name: "1er Groupe I", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "3e Groupe C/D/F/G/H", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-06-30T23:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe I vs. 3e Groupe C/D/F/G/H.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-7",

        stage: "32es",

        date: "07/01",

        time: "03:00",

        group: "16es de finale",

        teamA: { name: "1er Groupe A", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "3e Groupe C/E/F/H/I", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-01T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe A vs. 3e Groupe C/E/F/H/I.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-8",

        stage: "32es",

        date: "07/01",

        time: "18:00",

        group: "16es de finale",

        teamA: { name: "1er Groupe L", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "3e Groupe E/H/I/J/K", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-01T18:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe L vs. 3e Groupe E/H/I/J/K.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-9",

        stage: "32es",

        date: "07/01",

        time: "22:00",

        group: "16es de finale",

        teamA: { name: "1er Groupe G", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "3e Groupe A/E/H/I/J", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-01T22:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe G vs. 3e Groupe A/E/H/I/J.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-10",

        stage: "32es",

        date: "07/02",

        time: "02:00",

        group: "16es de finale",

        teamA: { name: "1er Groupe D", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "3e Groupe B/E/F/I/J", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-02T02:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe D vs. 3e Groupe B/E/F/I/J.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-11",

        stage: "32es",

        date: "07/02",

        time: "21:00",

        group: "16es de finale",

        teamA: { name: "1er Groupe H", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "2e Groupe J", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-02T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe H vs. 2e Groupe J.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-12",

        stage: "32es",

        date: "07/03",

        time: "01:00",

        group: "16es de finale",

        teamA: { name: "2e Groupe K", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "2e Groupe L", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-03T01:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 2e Groupe K vs. 2e Groupe L.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-13",

        stage: "32es",

        date: "07/03",

        time: "05:00",

        group: "16es de finale",

        teamA: { name: "1er Groupe B", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "3e Groupe E/F/G/I/J", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-03T05:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe B vs. 3e Groupe E/F/G/I/J.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-14",

        stage: "32es",

        date: "07/03",

        time: "20:00",

        group: "16es de finale",

        teamA: { name: "2e Groupe D", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "2e Groupe G", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-03T20:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 2e Groupe D vs. 2e Groupe G.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-15",

        stage: "32es",

        date: "07/04",

        time: "00:00",

        group: "16es de finale",

        teamA: { name: "1er Groupe J", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "2e Groupe H", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-04T00:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe J vs. 2e Groupe H.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "16e-16",

        stage: "32es",

        date: "07/04",

        time: "03:30",

        group: "16es de finale",

        teamA: { name: "1er Groupe K", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "3e Groupe D/E/I/J/L", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-04T03:30:00+02:00",

        aiAnalysis: "Analyse IA pour le 16e de finale : 1er Groupe K vs. 3e Groupe D/E/I/J/L.\n\nCe match éliminatoire s'annonce d'une tension extrême. Les deux équipes voudront éviter les erreurs fatales en début de rencontre.\n\n**Forces Attendues** : Rigueur défensive et jeu de transition.\n**Facteur Clé** : L'impact mental et la gestion des prolongations/tirs au but."

    },

    {

        id: "8e-1",

        stage: "8es",

        date: "07/04",

        time: "19:00",

        group: "8es de finale",

        teamA: { name: "Vainqueur 16e #1", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 16e #2", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-04T19:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 8e de finale : Vainqueur 16e #1 vs. Vainqueur 16e #2.\n\nLes huitièmes de finale marquent l'entrée dans le très grand tableau de la compétition. Aucune marge d'erreur n'est possible."

    },

    {

        id: "8e-2",

        stage: "8es",

        date: "07/04",

        time: "23:00",

        group: "8es de finale",

        teamA: { name: "Vainqueur 16e #3", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 16e #4", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-04T23:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 8e de finale : Vainqueur 16e #3 vs. Vainqueur 16e #4.\n\nLes huitièmes de finale marquent l'entrée dans le très grand tableau de la compétition. Aucune marge d'erreur n'est possible."

    },

    {

        id: "8e-3",

        stage: "8es",

        date: "07/05",

        time: "22:00",

        group: "8es de finale",

        teamA: { name: "Vainqueur 16e #5", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 16e #6", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-05T22:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 8e de finale : Vainqueur 16e #5 vs. Vainqueur 16e #6.\n\nLes huitièmes de finale marquent l'entrée dans le très grand tableau de la compétition. Aucune marge d'erreur n'est possible."

    },

    {

        id: "8e-4",

        stage: "8es",

        date: "07/06",

        time: "02:00",

        group: "8es de finale",

        teamA: { name: "Vainqueur 16e #7", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 16e #8", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-06T02:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 8e de finale : Vainqueur 16e #7 vs. Vainqueur 16e #8.\n\nLes huitièmes de finale marquent l'entrée dans le très grand tableau de la compétition. Aucune marge d'erreur n'est possible."

    },

    {

        id: "8e-5",

        stage: "8es",

        date: "07/06",

        time: "21:00",

        group: "8es de finale",

        teamA: { name: "Vainqueur 16e #9", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 16e #10", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-06T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 8e de finale : Vainqueur 16e #9 vs. Vainqueur 16e #10.\n\nLes huitièmes de finale marquent l'entrée dans le très grand tableau de la compétition. Aucune marge d'erreur n'est possible."

    },

    {

        id: "8e-6",

        stage: "8es",

        date: "07/07",

        time: "02:00",

        group: "8es de finale",

        teamA: { name: "Vainqueur 16e #11", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 16e #12", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-07T02:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 8e de finale : Vainqueur 16e #11 vs. Vainqueur 16e #12.\n\nLes huitièmes de finale marquent l'entrée dans le très grand tableau de la compétition. Aucune marge d'erreur n'est possible."

    },

    {

        id: "8e-7",

        stage: "8es",

        date: "07/07",

        time: "18:00",

        group: "8es de finale",

        teamA: { name: "Vainqueur 16e #13", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 16e #14", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-07T18:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 8e de finale : Vainqueur 16e #13 vs. Vainqueur 16e #14.\n\nLes huitièmes de finale marquent l'entrée dans le très grand tableau de la compétition. Aucune marge d'erreur n'est possible."

    },

    {

        id: "8e-8",

        stage: "8es",

        date: "07/07",

        time: "22:00",

        group: "8es de finale",

        teamA: { name: "Vainqueur 16e #15", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 16e #16", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-07T22:00:00+02:00",

        aiAnalysis: "Analyse IA pour le 8e de finale : Vainqueur 16e #15 vs. Vainqueur 16e #16.\n\nLes huitièmes de finale marquent l'entrée dans le très grand tableau de la compétition. Aucune marge d'erreur n'est possible."

    },

    {

        id: "qf-1",

        stage: "quarters",

        date: "07/09",

        time: "22:00",

        group: "Quarts de finale",

        teamA: { name: "Vainqueur 8e #1", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 8e #2", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-09T22:00:00+02:00",

        aiAnalysis: "Analyse IA pour le Quart de finale : Vainqueur 8e #1 vs. Vainqueur 8e #2.\n\nLes quarts de finale réunissent le Top 8 mondial. Un match d'une intensité tactique extraordinaire."

    },

    {

        id: "qf-2",

        stage: "quarters",

        date: "07/10",

        time: "21:00",

        group: "Quarts de finale",

        teamA: { name: "Vainqueur 8e #3", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 8e #4", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-10T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour le Quart de finale : Vainqueur 8e #3 vs. Vainqueur 8e #4.\n\nLes quarts de finale réunissent le Top 8 mondial. Un match d'une intensité tactique extraordinaire."

    },

    {

        id: "qf-3",

        stage: "quarters",

        date: "07/11",

        time: "23:00",

        group: "Quarts de finale",

        teamA: { name: "Vainqueur 8e #5", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 8e #6", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-11T23:00:00+02:00",

        aiAnalysis: "Analyse IA pour le Quart de finale : Vainqueur 8e #5 vs. Vainqueur 8e #6.\n\nLes quarts de finale réunissent le Top 8 mondial. Un match d'une intensité tactique extraordinaire."

    },

    {

        id: "qf-4",

        stage: "quarters",

        date: "07/12",

        time: "03:00",

        group: "Quarts de finale",

        teamA: { name: "Vainqueur 8e #7", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur 8e #8", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-12T03:00:00+02:00",

        aiAnalysis: "Analyse IA pour le Quart de finale : Vainqueur 8e #7 vs. Vainqueur 8e #8.\n\nLes quarts de finale réunissent le Top 8 mondial. Un match d'une intensité tactique extraordinaire."

    },

    {

        id: "df-1",

        stage: "semis",

        date: "07/14",

        time: "21:00",

        group: "Demi-finales",

        teamA: { name: "Vainqueur Q1", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur Q2", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-14T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour la Demi-finale : Vainqueur Q1 vs. Vainqueur Q2.\n\nLe dernier carré. La marche ultime avant le match d'une vie."

    },

    {

        id: "df-2",

        stage: "semis",

        date: "07/15",

        time: "21:00",

        group: "Demi-finales",

        teamA: { name: "Vainqueur Q3", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur Q4", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-15T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour la Demi-finale : Vainqueur Q3 vs. Vainqueur Q4.\n\nLe dernier carré. La marche ultime avant le match d'une vie."

    },

    {

        id: "third-place",

        stage: "final",

        date: "07/18",

        time: "23:00",

        group: "Finales",

        teamA: { name: "Perdant DF1", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Perdant DF2", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-18T23:00:00+02:00",

        aiAnalysis: "Analyse IA pour : Perdant DF1 vs. Perdant DF2.\n\nLe sommet du football mondial. 90 minutes pour entrer dans la légende."

    },

    {

        id: "final",

        stage: "final",

        date: "07/19",

        time: "21:00",

        group: "Finales",

        teamA: { name: "Vainqueur DF1", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        teamB: { name: "Vainqueur DF2", code: "TBD", flag: "https://flagcdn.com/w80/un.png" },

        status: "À venir",

        kickoff: "2026-07-19T21:00:00+02:00",

        aiAnalysis: "Analyse IA pour : Vainqueur DF1 vs. Vainqueur DF2.\n\nLe sommet du football mondial. 90 minutes pour entrer dans la légende."

    },

];



const getCountdown = (kickoffStr) => {

    if (!kickoffStr) return { days: 0, hours: 0, minutes: 0, seconds: 0, finished: true };

    const diff = new Date(kickoffStr) - new Date();

    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0, finished: true };

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));

    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);

    const minutes = Math.floor((diff / (1000 * 60)) % 60);

    const seconds = Math.floor((diff / 1000) % 60);

    return { days, hours, minutes, seconds, finished: false };

};





const getInitialStageAndDate = () => {

    const today = new Date();

    const comparisonDate = new Date(2026, today.getMonth(), today.getDate());



    const allDateEntries = [];

    Object.entries(DATES_BY_STAGE).forEach(([stage, dates]) => {

        dates.forEach(dateStr => {

            const [month, day] = dateStr.split("/").map(Number);

            const dateObj = new Date(2026, month - 1, day);

            allDateEntries.push({ stage, dateStr, dateObj });

        });

    });



    if (allDateEntries.length === 0) {

        return { stage: "groups", date: "06/11" };

    }



    let closestEntry = allDateEntries[0];

    let minDiff = Math.abs(comparisonDate - closestEntry.dateObj);



    for (let i = 1; i < allDateEntries.length; i++) {

        const entry = allDateEntries[i];

        const diff = Math.abs(comparisonDate - entry.dateObj);

        if (diff < minDiff) {

            minDiff = diff;

            closestEntry = entry;

        }

    }



    return { stage: closestEntry.stage, date: closestEntry.dateStr };

};



const TEAM_TRANSLATIONS = {

    "Mexico": "Mexique",

    "South Africa": "Afrique du Sud",

    "South Korea": "Corée du Sud",

    "Korea Republic": "Corée du Sud",

    "Czechia": "Rép. tchèque",

    "Czech Republic": "Rép. tchèque",

    "Canada": "Canada",

    "Bosnia-Herzegovina": "Bosnie-Herzégovine",

    "Qatar": "Qatar",

    "Switzerland": "Suisse",

    "Brazil": "Brésil",

    "Morocco": "Maroc",

    "Haiti": "Haïti",

    "Scotland": "Écosse",

    "United States": "États-Unis",

    "USA": "États-Unis",

    "Paraguay": "Paraguay",

    "Australia": "Australie",

    "Turkey": "Turquie",

    "Germany": "Allemagne",

    "Curaçao": "Curaçao",

    "Ivory Coast": "Côte d'Ivoire",

    "Ecuador": "Equateur",

    "Netherlands": "Pays-Bas",

    "Japan": "Japon",

    "Sweden": "Suède",

    "Tunisia": "Tunisie",

    "Belgium": "Belgique",

    "Egypt": "Égypte",

    "Iran": "Iran",

    "New Zealand": "Nouvelle-Zélande",

    "Spain": "Espagne",

    "Cape Verde": "Cap-Vert",

    "Cape Verde Islands": "Cap-Vert",

    "Saudi Arabia": "Arabie saoudite",

    "Uruguay": "Uruguay",

    "France": "France",

    "Senegal": "Sénégal",

    "Iraq": "Irak",

    "Norway": "Norvège",

    "Argentina": "Argentine",

    "Algeria": "Algérie",

    "Austria": "Autriche",

    "Jordan": "Jordanie",

    "Portugal": "Portugal",

    "Congo DR": "RD Congo",

    "DR Congo": "RD Congo",

    "Uzbekistan": "Ouzbékistan",

    "Colombia": "Colombie",

    "England": "Angleterre",

    "Croatia": "Croatie",

    "Ghana": "Ghana",

    "Panama": "Panama"

};



const TEAM_STYLES = {

    ESP: { att: 1.18, def: 0.95 },  // Attaque très forte, défense solide

    BRA: { att: 1.15, def: 1.05 },  // Attaque forte, défense un peu plus vulnérable

    GER: { att: 1.20, def: 1.10 },  // Très offensif, encaisse pas mal

    FRA: { att: 1.08, def: 0.85 },  // Très équilibré, défense de fer

    ARG: { att: 1.10, def: 0.90 },  // Équilibré, grinta défensive

    MAR: { att: 0.85, def: 0.80 },  // Bloc bas, contre-attaque, défense imperméable

    ITA: { att: 0.90, def: 0.85 },  // Catennacio moderne

    CRO: { att: 0.95, def: 0.90 },  // Tactique, compact

    ENG: { att: 1.05, def: 0.92 },  // Solide

    NED: { att: 1.12, def: 1.02 },  // Jeu ouvert

    POR: { att: 1.15, def: 0.95 },  // Complet

    BEL: { att: 1.10, def: 1.05 },  // Attaque correcte, défense vieillissante

    URU: { att: 1.05, def: 0.88 },  // Intense, physique, solide

    COL: { att: 1.08, def: 0.92 },  // Technique, équilibré

    JPN: { att: 1.05, def: 0.95 },  // Collectif, discipliné

    USA: { att: 1.02, def: 1.00 },  // Neutre/Équilibré

    MEX: { att: 1.00, def: 0.98 },  // Solide

};



const getTeamStyle = (code) => {

    if (TEAM_STYLES[code]) return TEAM_STYLES[code];

    let hash = 0;

    for (let i = 0; i < code.length; i++) {

        hash = code.charCodeAt(i) + ((hash << 5) - hash);

    }

    const att = 0.90 + (Math.abs(hash % 20) / 100);

    const def = 0.90 + (Math.abs((hash >> 4) % 20) / 100);

    return { att, def };

};



const getStyleLabel = (style) => {

    if (style.att >= 1.12 && style.def >= 1.02) return "Ultra-Offensif";

    if (style.att >= 1.08 && style.def <= 0.95) return "Attaque & Solidité";

    if (style.att <= 0.92 && style.def <= 0.88) return "Bloc Compact";

    if (style.def <= 0.88) return "Défense de Fer";

    if (style.att >= 1.08) return "Offensif";

    if (style.att <= 0.92) return "Défensif";

    return "Équilibré";

};



const CoupeDuMonde = () => {

    const { state: simState, run: runSimulation, reset: resetSimulation } = useSimulation();



    // Trigger confetti when simulation finishes successfully

    useEffect(() => {

        if (simState.status === "done") {

            confetti({

                particleCount: 150,

                spread: 80,

                origin: { y: 0.6 }

            });

        }

    }, [simState.status]);



    const [activeTab, setActiveTab] = useState("prono"); // "prono" | "standings" | "bracket"

    const [bracketFilter, setBracketFilter] = useState("confirmed"); // "as_it_stands" | "confirmed"

    const [selectedStage, setSelectedStage] = useState("groups");

    const [selectedDate, setSelectedDate] = useState("06/11");



    // Initialize stage and date based on current client date on mount

    useEffect(() => {

        const init = getInitialStageAndDate();

        setSelectedStage(init.stage);

        setSelectedDate(init.date);

    }, []);

    const [matches, setMatches] = useState(MATCHES);

    const [selectedMatch, setSelectedMatch] = useState(null);

    const [predictions, setPredictions] = useState(() => {

        try {

            const saved = localStorage.getItem("predictions_2026");

            return saved ? JSON.parse(saved) : {};

        } catch {

            return {};

        }

    });

    const [odds, setOdds] = useState([]);

    const [simResult, setSimResult] = useState(null);

    const [isSimulating, setIsSimulating] = useState(false);

    const [voteStats, setVoteStats] = useState(null);

    const [userVote, setUserVote] = useState(null);

    const [isVoting, setIsVoting] = useState(false);

    const [visitorId, setVisitorId] = useState("");

    const [tick, setTick] = useState(0);



    const [isSyncing, setIsSyncing] = useState(false);

    const [syncSuccess, setSyncSuccess] = useState(null);

    const [syncError, setSyncError] = useState(null);



    // Update countdown timer every second

    useEffect(() => {

        const timer = setInterval(() => setTick(t => t + 1), 1000);

        return () => clearInterval(timer);

    }, []);



    // Save predictions to localStorage

    useEffect(() => {

        localStorage.setItem("predictions_2026", JSON.stringify(predictions));

    }, [predictions]);

    

    const dateSelectorRef = useRef(null);



    // API Sync for football-data.org (WC 2026 Season) via secure backend proxy

    const syncFromFootballData = useCallback(async () => {

        setIsSyncing(true);

        setSyncError(null);

        setSyncSuccess(null);

        try {

            const apiBaseUrl = process.env.REACT_APP_BACKEND_URL || "";

            const res = await axios.get(`${apiBaseUrl}/api/worldcup/matches`);

            

            const data = res.data;

            if (data && data.matches) {

                const apiMatches = data.matches;

                

                const mapApiStageToUiStage = (apiStage) => {

                    switch (apiStage) {

                        case "GROUP_STAGE": return "groups";

                        case "LAST_32": return "32es";

                        case "LAST_16": return "8es";

                        case "QUARTER_FINALS": return "quarters";

                        case "SEMI_FINALS": return "semis";

                        case "THIRD_PLACE":

                        case "FINAL": return "final";

                        default: return "groups";

                    }

                };



                const apiStageMatches = {};

                apiMatches.forEach(am => {

                    const uiStage = mapApiStageToUiStage(am.stage);

                    if (!apiStageMatches[uiStage]) apiStageMatches[uiStage] = [];

                    apiStageMatches[uiStage].push(am);

                });



                Object.keys(apiStageMatches).forEach(stage => {

                    apiStageMatches[stage].sort((a, b) => new Date(a.utcDate) - new Date(b.utcDate));

                });



                const teamCodesMatch = (uiCode, apiCode) => {

                    if (!uiCode || !apiCode) return false;

                    const u = uiCode.toUpperCase();

                    const a = apiCode.toUpperCase();

                    if (u === a) return true;

                    if (u === "URU" && a === "URY") return true;

                    if (u === "URY" && a === "URU") return true;

                    return false;

                };



                setMatches(prev => {

                    const uiStageMatches = {};

                    prev.forEach(m => {

                        if (!uiStageMatches[m.stage]) uiStageMatches[m.stage] = [];

                        uiStageMatches[m.stage].push(m);

                    });



                    Object.keys(uiStageMatches).forEach(stage => {

                        uiStageMatches[stage].sort((a, b) => new Date(a.kickoff) - new Date(b.kickoff));

                    });



                    return prev.map(m => {

                        let apiMatch = null;

                        if (m.stage === "groups") {

                            // Match by team codes

                            const stageMatches = apiStageMatches["groups"] || [];

                            apiMatch = stageMatches.find(am => {

                                const apiHome = am.homeTeam?.tla || am.homeTeam?.code || "";

                                const apiAway = am.awayTeam?.tla || am.awayTeam?.code || "";

                                return (teamCodesMatch(m.teamA.code, apiHome) && teamCodesMatch(m.teamB.code, apiAway)) ||

                                       (teamCodesMatch(m.teamA.code, apiAway) && teamCodesMatch(m.teamB.code, apiHome));

                            });

                        } else {

                            // Match by index within the stage

                            const stageMatches = uiStageMatches[m.stage] || [];

                            const matchIndex = stageMatches.findIndex(sm => sm.id === m.id);

                            apiMatch = (apiStageMatches[m.stage] || [])[matchIndex];

                        }



                        if (apiMatch) {

                            const scoreA = apiMatch.score?.fullTime?.home !== undefined && apiMatch.score?.fullTime?.home !== null ? apiMatch.score.fullTime.home : null;

                            const scoreB = apiMatch.score?.fullTime?.away !== undefined && apiMatch.score?.fullTime?.away !== null ? apiMatch.score.fullTime.away : null;

                            

                            const updated = {

                                ...m,

                                apiId: apiMatch.id,

                                scoreA: scoreA,

                                scoreB: scoreB,

                                status: apiMatch.status === "FINISHED" ? "Terminé" : 

                                        apiMatch.status === "IN_PLAY" ? "En direct" : "À venir",

                                idEvent: apiMatch.idEvent,

                                poster: apiMatch.poster,

                                thumb: apiMatch.thumb,

                                video_url: apiMatch.video_url,

                                banner: apiMatch.banner,

                                venue: apiMatch.venue,

                                city: apiMatch.city,

                                country: apiMatch.country,

                                league_badge: apiMatch.league_badge,

                                home_badge: apiMatch.home_badge,

                                away_badge: apiMatch.away_badge

                            };



                            if (apiMatch.homeTeam && apiMatch.homeTeam.name && (m.teamA.code === "TBD" || m.teamA.name.startsWith("1er") || m.teamA.name.startsWith("2e") || m.teamA.name.startsWith("3e") || m.teamA.name.startsWith("Vainqueur") || m.teamA.name.startsWith("Perdant"))) {

                                const apiName = apiMatch.homeTeam.name;

                                updated.teamA = {

                                    name: TEAM_TRANSLATIONS[apiName] || apiName,

                                    code: apiMatch.homeTeam.tla || apiMatch.homeTeam.code,

                                    flag: apiMatch.homeTeam.crest || `https://flagcdn.com/w80/${(apiMatch.homeTeam.tla || "").substring(0, 2).toLowerCase()}.png`

                                };

                            }

                            if (apiMatch.awayTeam && apiMatch.awayTeam.name && (m.teamB.code === "TBD" || m.teamB.name.startsWith("1er") || m.teamB.name.startsWith("2e") || m.teamB.name.startsWith("3e") || m.teamB.name.startsWith("Vainqueur") || m.teamB.name.startsWith("Perdant"))) {

                                const apiName = apiMatch.awayTeam.name;

                                updated.teamB = {

                                    name: TEAM_TRANSLATIONS[apiName] || apiName,

                                    code: apiMatch.awayTeam.tla || apiMatch.awayTeam.code,

                                    flag: apiMatch.awayTeam.crest || `https://flagcdn.com/w80/${(apiMatch.awayTeam.tla || "").substring(0, 2).toLowerCase()}.png`

                                };

                            }



                            if (apiMatch.score?.penalties) {

                                updated.pensA = apiMatch.score.penalties.home;

                                updated.pensB = apiMatch.score.penalties.away;

                            }



                            return updated;

                        }

                        return m;

                    });

                });

                setSyncSuccess("Scores Coupe du Monde 2026 synchronisés en direct !");

            } else {

                throw new Error("Format de réponse de l'API invalide");

            }

        } catch (e) {

            console.error(e);

            setSyncError("Impossible de synchroniser en direct (l'API de repli local reste active).");

        } finally {

            setIsSyncing(false);

        }

    }, []);



    // Auto-sync on mount

    useEffect(() => {

        syncFromFootballData();

    }, [syncFromFootballData]);



    // Charger les cotes des bookmakers au montage du composant

    useEffect(() => {

        let cancelled = false;

        const fetchOddsData = async () => {

            try {

                const apiBaseUrl = process.env.REACT_APP_BACKEND_URL || "";

                const { data } = await axios.get(`${apiBaseUrl}/api/odds`);

                if (!cancelled) {

                    setOdds(data);

                }

            } catch (error) {

                console.error("Error fetching bookmaker odds:", error);

            }

        };

        fetchOddsData();

        return () => {

            cancelled = true;

        };

    }, []);



    // Build teams map dynamically

    const teams2026Map = useMemo(() => {

        const map = {};

        matches.forEach(m => {

            if (m.teamA && m.teamA.code) {

                map[m.teamA.code] = m.teamA;

            }

            if (m.teamB && m.teamB.code) {

                map[m.teamB.code] = m.teamB;

            }

        });

        return map;

    }, [matches]);



    // Build groups dynamically

    const groups2026 = useMemo(() => {

        const groups = {};

        matches.forEach(m => {

            if (m.stage !== "groups" || !m.group) return;

            const match = m.group.match(/Groupe\s+([A-L])/);

            if (match) {

                const groupLetter = match[1];

                if (!groups[groupLetter]) groups[groupLetter] = new Set();

                if (m.teamA && m.teamA.code) groups[groupLetter].add(m.teamA.code);

                if (m.teamB && m.teamB.code) groups[groupLetter].add(m.teamB.code);

            }

        });

        

        return Object.keys(groups).sort().map(key => ({

            key,

            name: `Groupe ${key}`,

            teams: Array.from(groups[key])

        }));

    }, [matches]);



    // Calculate group standings dynamically

    const computedStandings = useMemo(() => {

        const standings = {};

        groups2026.forEach(g => {

            standings[g.key] = g.teams.map((code, idx) => {

                const team = teams2026Map[code] || { name: code, code, flag: "" };

                return {

                    ...team,

                    p: 0,

                    gf: 0,

                    ga: 0,

                    gd: 0,

                    pts: 0,

                    drawIndex: idx + 1

                };

            });

        });



        matches.forEach(m => {

            if (m.stage !== "groups" || !m.group) return;

            const match = m.group.match(/Groupe\s+([A-L])/);

            if (!match) return;

            const groupKey = match[1];

            const groupStandings = standings[groupKey];

            if (!groupStandings) return;



            const home = groupStandings.find(t => t.code === m.teamA.code);

            const away = groupStandings.find(t => t.code === m.teamB.code);



            if (!home || !away) return;

            if (m.scoreA === null || m.scoreB === null) return;



            home.p += 1;

            away.p += 1;

            home.gf += m.scoreA;

            home.ga += m.scoreB;

            away.gf += m.scoreB;

            away.ga += m.scoreA;

            home.gd = home.gf - home.ga;

            away.gd = away.gf - away.ga;



            if (m.scoreA > m.scoreB) {

                home.pts += 3;

            } else if (m.scoreA < m.scoreB) {

                away.pts += 3;

            } else {

                home.pts += 1;

                away.pts += 1;

            }

        });



        Object.keys(standings).forEach(k => {

            standings[k].sort((a, b) => {

                return b.pts - a.pts || b.gd - a.gd || b.gf - a.gf || a.drawIndex - b.drawIndex;

            });

        });



        return standings;

    }, [matches, groups2026, teams2026Map]);



    // Mettre à jour le match sélectionné par défaut si la date change

    useEffect(() => {

        const matchesForDate = matches.filter(

            (m) => m.stage === selectedStage && m.date === selectedDate

        );

        if (matchesForDate.length > 0) {

            setSelectedMatch(matchesForDate[0]);

        } else {

            setSelectedMatch(null);

        }

    }, [selectedStage, selectedDate, matches]);



    const normalizeName = (name) => {

        if (!name) return "";

        const NAME_MAP = {

            'Rep. tchèque': 'République Tchèque',

            'Rép. tchèque': 'République Tchèque',

            'RD Congo': 'Congo DR',

            'Equateur': 'Équateur',

            'Curaçao': 'Curacao',

            'Afrique du Sud': 'South Africa',

            'Corée du Sud': 'South Korea',

            'Nouvelle-Zélande': 'New Zealand',

            'Arabie saoudite': 'Saudi Arabia',

            'Arabie Saoudite': 'Saudi Arabia',

            'Belgique': 'Belgium',

            'Allemagne': 'Germany',

            'Espagne': 'Spain',

            'Italie': 'Italy',

            'Angleterre': 'England',

            'Pays-Bas': 'Netherlands',

            'Maroc': 'Morocco',

            'Brésil': 'Brazil',

            'Mexique': 'Mexico',

            'Algérie': 'Algeria',

            'Autriche': 'Austria',

            'Suède': 'Sweden',

            'Égypte': 'Egypt',

            'Croatie': 'Croatia',

            'Tunisie': 'Tunisia',

            'Norvège': 'Norway',

            'Suisse': 'Switzerland',

            'Japon': 'Japan'

        };

        const mapped = NAME_MAP[name];

        const target = mapped || name;

        return target

            .toLowerCase()

            .normalize("NFD")

            .replace(/[\u0300-\u036f]/g, "")

            .replace(/rép\.\s+tchèque/g, "republique tcheque")

            .replace(/rep\.\s+tcheque/g, "republique tcheque")

            .replace(/états-unis/g, "usa")

            .replace(/etats unis/g, "usa")

            .replace(/united states/g, "usa")

            .trim();

    };



    const findOddsForMatch = useCallback((m, oddsList) => {

        if (!m || !oddsList || oddsList.length === 0) return null;

        const nameA = normalizeName(m.teamA.name);

        const nameB = normalizeName(m.teamB.name);

        return oddsList.find(o => {

            if (o.competition !== 'Coupe du Monde') return false;

            const homeName = normalizeName(o.home);

            const awayName = normalizeName(o.away);

            return (

                (homeName === nameA && awayName === nameB) ||

                (homeName === nameB && awayName === nameA)

            );

        });

    }, []);







    const runMatchSimulation = useCallback((m, oddsList) => {

        if (!m) return null;

        

        const teamAData = TEAMS.find(t => t.id === m.teamA.code) || { id: m.teamA.code, elo: 1500, is_host: false };

        const teamBData = TEAMS.find(t => t.id === m.teamB.code) || { id: m.teamB.code, elo: 1500, is_host: false };

        

        const styleA = getTeamStyle(teamAData.id);

        const styleB = getTeamStyle(teamBData.id);

        

        const isKnockout = m.stage !== "groups";

        const stage = m.stage === "groups" ? "group" : m.stage;

        

        const eloA = effectiveElo(teamAData, stage);

        const eloB = effectiveElo(teamBData, stage);

        const bonusA = teamAData.is_host && !isKnockout ? 100 : 0;

        const bonusB = teamBData.is_host && !isKnockout ? 100 : 0;

        

        // 1. Calcul des trois indices de performance (0 à 100) basés sur l'ELO et la forme

        const ipA = Math.min(100, Math.max(0, (teamAData.elo - 1000) / 12));

        const ipB = Math.min(100, Math.max(0, (teamBData.elo - 1000) / 12));

        

        const demiA = Math.min(100, Math.max(0, (teamAData.elo - 1200) / 10));

        const demiB = Math.min(100, Math.max(0, (teamBData.elo - 1200) / 10));

        

        const formAdjA = recentFormAdjustment(teamAData);

        const formAdjB = recentFormAdjustment(teamBData);

        const formeA = Math.min(100, Math.max(0, 50 + (formAdjA * 100) / 300));

        const formeB = Math.min(100, Math.max(0, 50 + (formAdjB * 100) / 300));

        

        // 2. Calcul des forces avec la pondération 50% / 20% / 30%

        const w1 = 0.50, w2 = 0.20, w3 = 0.30;

        let forceA = w1 * ipA + w2 * demiA + w3 * formeA;

        let forceB = w1 * ipB + w2 * demiB + w3 * formeB;

        

        // 3. Ajustement pour les absences et l'avantage à domicile

        const absenceA = absenceAdjustment(teamAData, stage);

        const absenceB = absenceAdjustment(teamBData, stage);

        forceA = Math.max(1, forceA + (absenceA / 12) + (bonusA / 12));

        forceB = Math.max(1, forceB + (absenceB / 12) + (bonusB / 12));

        

        // 4. Calcul du ratio de force pour la distribution de Poisson

        const ratio = Math.sqrt(forceA / forceB || 1);

        const baseGoals = 1.30;

        

        let lambdaA = Math.min(4.5, Math.max(0.15, baseGoals * ratio * styleA.att * styleB.def));

        let lambdaB = Math.min(4.5, Math.max(0.15, (baseGoals / ratio) * styleB.att * styleA.def));

        

        const rng = new XoshiroRNG(Math.random() * 1000000);

        let winsA = 0;

        let draws = 0;

        let winsB = 0;

        

        let qualWinsA = 0;

        let qualWinsB = 0;

        

        const scoreHist = {};

        const iterations = 10000;

        

        for (let i = 0; i < iterations; i++) {

            const ga = samplePoisson(lambdaA, rng);

            const gb = samplePoisson(lambdaB, rng);

            

            const scoreKey = `${ga}-${gb}`;

            scoreHist[scoreKey] = (scoreHist[scoreKey] || 0) + 1;

            

            if (ga > gb) {

                winsA++;

                qualWinsA++;

            } else if (ga < gb) {

                winsB++;

                qualWinsB++;

            } else {

                draws++;

                if (isKnockout) {

                    const pA = shootoutWinProb(teamAData.id, teamBData.id);

                    if (rng.next() < pA) {

                        qualWinsA++;

                    } else {

                        qualWinsB++;

                    }

                }

            }

        }

        

        const topScores = Object.entries(scoreHist)

            .map(([key, count]) => {

                const [ga, gb] = key.split("-").map(Number);

                return {

                    score: `${ga} - ${gb}`,

                    pct: (count / iterations) * 100,

                    count

                };

            })

            .sort((a, b) => b.count - a.count)

            .slice(0, 5);

            

        const probHome = (winsA / iterations) * 100;

        const probDraw = (draws / iterations) * 100;

        const probAway = (winsB / iterations) * 100;

        

        const matchedOdds = findOddsForMatch(m, oddsList);

        let calculatedOdds = null;

        let isRealOdds = false;

        

        if (matchedOdds && matchedOdds.odds && matchedOdds.odds.length > 0) {

            const bookmakerOdds = matchedOdds.odds;

            const count = bookmakerOdds.length;

            const isFlipped = normalizeName(matchedOdds.home) === normalizeName(m.teamB.name);

            

            const winamax = bookmakerOdds.find(o => o.bookmaker.toLowerCase() === 'winamax');

            if (winamax) {

                calculatedOdds = {

                    home: isFlipped ? winamax.away : winamax.home,

                    draw: winamax.draw,

                    away: isFlipped ? winamax.home : winamax.away,

                };

            } else {

                calculatedOdds = {

                    home: bookmakerOdds.reduce((sum, o) => sum + (isFlipped ? o.away : o.home), 0) / count,

                    draw: bookmakerOdds.reduce((sum, o) => sum + o.draw, 0) / count,

                    away: bookmakerOdds.reduce((sum, o) => sum + (isFlipped ? o.home : o.away), 0) / count,

                };

            }

            isRealOdds = true;

        } else {

            calculatedOdds = {

                home: Math.max(1.01, 1.06 / (probHome / 100 || 0.01)),

                draw: Math.max(1.01, 1.06 / (probDraw / 100 || 0.01)),

                away: Math.max(1.01, 1.06 / (probAway / 100 || 0.01)),

            };

            isRealOdds = false;

        }

        

        return {

            winsA: probHome,

            draws: probDraw,

            winsB: probAway,

            qualWinsA: isKnockout ? (qualWinsA / iterations) * 100 : null,

            qualWinsB: isKnockout ? (qualWinsB / iterations) * 100 : null,

            topScores,

            odds: calculatedOdds,

            isRealOdds,

            eloDetails: {

                a: {

                    base: teamAData.elo,

                    form: recentFormAdjustment(teamAData),

                    absence: absenceAdjustment(teamAData, stage),

                    effective: effectiveElo(teamAData, stage),

                    style: styleA,

                    styleLabel: getStyleLabel(styleA)

                },

                b: {

                    base: teamBData.elo,

                    form: recentFormAdjustment(teamBData),

                    absence: absenceAdjustment(teamBData, stage),

                    effective: effectiveElo(teamBData, stage),

                    style: styleB,

                    styleLabel: getStyleLabel(styleB)

                }

            }

        };

        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, [findOddsForMatch]);



    useEffect(() => {

        if (!selectedMatch) {

            setSimResult(null);

            return;

        }



        if (selectedMatch.teamA.code === "TBD" || selectedMatch.teamB.code === "TBD") {

            setSimResult(null);

            setIsSimulating(false);

            return;

        }

        

        setIsSimulating(true);

        const timer = setTimeout(() => {

            const result = runMatchSimulation(selectedMatch, odds);

            setSimResult(result);

            setIsSimulating(false);

        }, 350);

        

        return () => clearTimeout(timer);

    }, [selectedMatch, odds, runMatchSimulation]);



    // Initialize visitor ID on mount

    useEffect(() => {

        let vid = localStorage.getItem("pronospot_visitor_id");

        if (!vid) {

            vid = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

            localStorage.setItem("pronospot_visitor_id", vid);

        }

        setVisitorId(vid);

    }, []);



    // Load vote stats and user vote when selectedMatch changes

    useEffect(() => {

        if (!selectedMatch) {

            setVoteStats(null);

            setUserVote(null);

            return;

        }



        // Load local user vote from localStorage for this match

        try {

            const savedVotes = localStorage.getItem("pronospot_match_votes");

            const votesMap = savedVotes ? JSON.parse(savedVotes) : {};

            setUserVote(votesMap[selectedMatch.id] || null);

        } catch {

            setUserVote(null);

        }



        // Fetch vote statistics from backend

        const fetchVoteStats = async () => {

            const apiBaseUrl = process.env.REACT_APP_BACKEND_URL || "";

            try {

                const res = await axios.get(`${apiBaseUrl}/api/worldcup/matches/${selectedMatch.id}/votes`);

                setVoteStats(res.data);

            } catch (err) {

                console.error("Error fetching vote stats:", err);

            }

        };



        fetchVoteStats();

    }, [selectedMatch]);



    const handleVote = async (choice) => {

        if (!selectedMatch || !visitorId || isVoting) return;

        setIsVoting(true);

        const apiBaseUrl = process.env.REACT_APP_BACKEND_URL || "";

        try {

            const res = await axios.post(`${apiBaseUrl}/api/worldcup/matches/${selectedMatch.id}/votes`, {

                visitor_id: visitorId,

                choice: choice

            });

            // Update stats

            setVoteStats(res.data);

            // Save choice in localStorage

            setUserVote(choice);

            try {

                const savedVotes = localStorage.getItem("pronospot_match_votes");

                const votesMap = savedVotes ? JSON.parse(savedVotes) : {};

                votesMap[selectedMatch.id] = choice;

                localStorage.setItem("pronospot_match_votes", JSON.stringify(votesMap));

            } catch (e) {

                console.error("Failed to save vote to localStorage", e);

            }

        } catch (err) {

            console.error("Error submitting vote:", err);

        } finally {

            setIsVoting(false);

        }

    };



    // Auto-scroll the selected date into view

    useEffect(() => {

        const timer = setTimeout(() => {

            if (selectedDate && dateSelectorRef.current) {

                const container = dateSelectorRef.current;

                const buttons = container.querySelectorAll("button");

                let targetButton = null;

                buttons.forEach(btn => {

                    if (btn.textContent.includes(selectedDate)) {

                        targetButton = btn;

                    }

                });

                if (targetButton) {

                    const containerRect = container.getBoundingClientRect();

                    const buttonRect = targetButton.getBoundingClientRect();

                    const scrollLeftOffset = container.scrollLeft + (buttonRect.left - containerRect.left) - (containerRect.width / 2) + (buttonRect.width / 2);

                    container.scrollTo({

                        left: scrollLeftOffset,

                        behavior: "smooth"

                    });

                }

            }

        }, 100);

        return () => clearTimeout(timer);

    }, [selectedDate, selectedStage]);



    // Enable mouse wheel horizontal scrolling on the dates container

    useEffect(() => {

        const container = dateSelectorRef.current;

        if (!container) return;

        const onWheel = (e) => {

            if (e.deltaY !== 0) {

                e.preventDefault();

                container.scrollLeft += e.deltaY;

            }

        };

        container.addEventListener("wheel", onWheel, { passive: false });

        return () => container.removeEventListener("wheel", onWheel);

    }, []);



    const handleStageChange = (stageId) => {

        setSelectedStage(stageId);

        const dates = DATES_BY_STAGE[stageId] || [];

        if (dates.length > 0) {

            setSelectedDate(dates[0]);

        }

    };



    const handlePredict = async (matchId, value) => {

        // Find the match in the list to select it

        const matchObj = matches.find(m => m.id === matchId);

        if (matchObj) {

            setSelectedMatch(matchObj);

        }



        // Update local predictions immediately for fast UI response

        setPredictions(prev => ({

            ...prev,

            [matchId]: value

        }));



        if (!visitorId) return;



        setIsVoting(true);

        const apiBaseUrl = process.env.REACT_APP_BACKEND_URL || "";

        try {

            const res = await axios.post(`${apiBaseUrl}/api/worldcup/matches/${matchId}/votes`, {

                visitor_id: visitorId,

                choice: value

            });



            // Save choice in local storage votes map

            try {

                const savedVotes = localStorage.getItem("pronospot_match_votes");

                const votesMap = savedVotes ? JSON.parse(savedVotes) : {};

                votesMap[matchId] = value;

                localStorage.setItem("pronospot_match_votes", JSON.stringify(votesMap));

            } catch (e) {

                console.error("Failed to save vote to localStorage", e);

            }



            // Update userVote and voteStats for the sidebar display

            setVoteStats(res.data);

            setUserVote(value);

        } catch (err) {

            console.error("Error submitting vote from card:", err);

        } finally {

            setIsVoting(false);

        }

    };







    const renderBracketMatch = (m, isGrandFinal = false) => {

        if (!m) {

            return (

                <div className="h-[90px] w-44 p-2 bg-[#162236]/40 border border-[#2A4A6B]/20 rounded-lg flex flex-col justify-center items-center text-[10px] text-gray-500 shrink-0 select-none">

                    À Déterminer

                </div>

            );

        }

        const prono = predictions[m.id];

        const isCompleted = m.scoreA !== null && m.scoreB !== null;

        

        return (

            <div 

                key={m.id} 

                className={`h-[90px] w-44 p-2 bg-[#162236] border ${

                    isGrandFinal 

                        ? "border-[#FFB300] shadow-[0_0_15px_rgba(255,179,0,0.15)]" 

                        : "border-[#2A4A6B]/50"

                } rounded-lg text-[11px] flex flex-col justify-between hover:border-[#00C853]/50 transition-colors shadow-md shrink-0 select-none block`}

            >

                <div className="flex justify-between items-center text-[9px] text-gray-400 border-b border-[#2A4A6B]/20 pb-0.5">

                    <span className="font-mono text-gray-500">{m.date} {m.time}</span>

                    <div className="flex items-center gap-1">
                        {m.video_url && (
                            <span className="text-[#00C853] shrink-0" title="Résumé Vidéo Disponible">
                                <Play size={8} className="fill-[#00C853] text-[#00C853]" />
                            </span>
                        )}
                        <span className={`font-semibold uppercase tracking-wider text-[8px] px-1 rounded ${

                            m.status === "Terminé" ? "bg-[#1E3A5F] text-white" : "bg-[#00C853]/15 text-[#00C853]"

                        }`}>

                            {m.status}

                        </span>
                    </div>

                </div>

                

                <div className="space-y-1">

                    {/* Team A */}

                    <div className="flex justify-between items-center">

                        <div className="flex items-center gap-1.5 truncate max-w-[130px]">

                            <img 

                                src={m.teamA.flag} 

                                alt={m.teamA.name} 

                                className="w-5.5 h-3.5 object-cover rounded border border-[#2A4A6B]/20 shrink-0" 

                            />

                            <span className={`font-semibold truncate ${

                                isCompleted && m.scoreA < m.scoreB ? "text-gray-500 line-through" : "text-white"

                            }`}>

                                {m.teamA.name}

                            </span>

                        </div>

                        <span className="font-mono font-bold text-white bg-[#0D1B2A] px-1.5 py-0.5 rounded text-[10px]">

                            {m.scoreA !== null ? m.scoreA : "-"}

                            {m.pensA !== undefined && <span className="text-[8px] text-gray-400 ml-0.5">({m.pensA})</span>}

                        </span>

                    </div>



                    {/* Team B */}

                    <div className="flex justify-between items-center">

                        <div className="flex items-center gap-1.5 truncate max-w-[130px]">

                            <img 

                                src={m.teamB.flag} 

                                alt={m.teamB.name} 

                                className="w-5.5 h-3.5 object-cover rounded border border-[#2A4A6B]/20 shrink-0" 

                            />

                            <span className={`font-semibold truncate ${

                                isCompleted && m.scoreB < m.scoreA ? "text-gray-500 line-through" : "text-white"

                            }`}>

                                {m.teamB.name}

                            </span>

                        </div>

                        <span className="font-mono font-bold text-white bg-[#0D1B2A] px-1.5 py-0.5 rounded text-[10px]">

                            {m.scoreB !== null ? m.scoreB : "-"}

                            {m.pensB !== undefined && <span className="text-[8px] text-gray-400 ml-0.5">({m.pensB})</span>}

                        </span>

                    </div>

                </div>

            </div>

        );

    };



    const activeDates = DATES_BY_STAGE[selectedStage] || [];

    const filteredMatches = matches.filter(

        (m) => m.stage === selectedStage && m.date === selectedDate

    );





    return (

        <div data-testid="world-cup-interactive-page" className="min-h-screen bg-[#0D1B2A] text-white">

            <SEO

                title="Pronostics Coupe du Monde 2026 | Assistant IA & Calendrier | Pronospot"

                description="Pariez sur la Coupe du Monde 2026 grâce à notre assistant de prédictions IA interactif. Calendrier complet des 104 matchs et classements en direct."

                jsonLd={[

                    breadcrumbSchema([

                        { name: "Accueil", url: "https://pronospot.com/" },

                        { name: "Coupe du Monde 2026", url: "https://pronospot.com/coupe-du-monde-2026" }

                    ]),

                    ...MATCHES.slice(0, 10).map(m => sportsEventSchema({ home: m.teamA.name, away: m.teamB.name, kickoff: m.kickoff }))

                ]}

            />



            {/* HEADER HERO */}

            <section className="relative overflow-hidden border-b border-[#2A4A6B] pt-10 pb-8 bg-gradient-to-b from-[#0D1B2A] via-[#10243C] to-[#0D1B2A]">

                <div className="container-x">

                    <Breadcrumbs items={[{ label: "Coupe du Monde 2026" }]} />

                    

                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mt-4">

                        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5">

                            <img 
                                src="https://r2.thesportsdb.com/images/media/league/badgearchive/z7ems41765247635.png" 
                                alt="Logo Coupe du Monde 2026" 
                                className="w-16 h-16 sm:w-20 sm:h-20 object-contain shrink-0" 
                            />

                            <div>

                                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#00C853]/15 border border-[#00C853]/30 mb-3">

                                    <Trophy className="text-[#00C853] animate-bounce" size={16} />

                                    <span className="text-xs font-bold text-[#00C853] uppercase tracking-widest">

                                        Événement Spécial 2026

                                    </span>

                                </div>

                                <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-white tracking-tighter">

                                    Espace Coupe du Monde 2026

                                </h1>

                                <p className="text-gray-400 mt-2 max-w-2xl text-base sm:text-lg">

                                    Pronostiquez les rencontres du plus grand tournoi de l'histoire et bénéficiez des analyses tactiques prédictives de notre IA d'aide à la décision.

                                </p>

                            </div>

                        </div>



                        <div className="flex bg-[#162236] p-1.5 rounded-xl border border-[#2A4A6B]/50 shrink-0 self-start md:self-center">

                            {[

                                { id: "prono", label: "🍺 Jeu Pronos & IA" },

                                { id: "standings", label: "📊 Groupes" },

                                { id: "bracket", label: "🏆 Tableau Final" }

                            ].map((tab) => (

                                <button

                                    key={tab.id}

                                    onClick={() => setActiveTab(tab.id)}

                                    className={`px-4 py-2.5 rounded-lg text-xs font-heading font-bold uppercase tracking-wider transition-all ${

                                        activeTab === tab.id

                                            ? "bg-[#00C853] text-[#000000] shadow-md shadow-[#00C853]/25"

                                            : "text-gray-400 hover:text-white"

                                    }`}

                                >

                                    {tab.label}

                                </button>

                            ))}

                        </div>

                    </div>





                </div>

            </section>



            {/* ONGLET 1: PRONOSTIQUER & IA */}

            {activeTab === "prono" && (

                <div className="container-x py-10 animate-fade-in">

                    

                    {/* TIMELINE STEPPER DE TOURNOI */}

                    <div className="mb-10" data-testid="world-cup-timeline">

                        <div className="flex justify-between items-center text-center mb-4 overflow-x-auto pb-2 scrollbar-hide">

                            {STAGES.map((s, idx) => (

                                <button

                                    key={s.id}

                                    onClick={() => handleStageChange(s.id)}

                                    className={`text-xs sm:text-sm font-heading font-bold px-3 py-1 whitespace-nowrap transition-colors relative ${

                                        selectedStage === s.id

                                            ? "text-[#00C853]"

                                            : "text-gray-400 hover:text-white"

                                    }`}

                                >

                                    {s.label}

                                    {selectedStage === s.id && (

                                        <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-1.5 h-1.5 rounded-full bg-[#00C853]" />

                                    )}

                                </button>

                            ))}

                        </div>

                        {/* Barre de progression visuelle */}

                        <div className="relative h-1 bg-[#162236] rounded-full overflow-hidden">

                            <div 

                                className="absolute top-0 left-0 h-full bg-[#00C853] transition-all duration-500"

                                style={{ 

                                    width: `${(STAGES.findIndex(s => s.id === selectedStage) / (STAGES.length - 1)) * 100}%` 

                                }}

                            />

                        </div>

                    </div>



                    {/* SELECTEUR DE DATE HORIZONTAL */}

                    {activeDates.length > 0 && (

                        <div className="relative mb-8 flex items-center border-b border-[#2A4A6B]/50">

                            <button 

                                onClick={() => dateSelectorRef.current?.scrollBy({ left: -200, behavior: 'smooth' })}

                                className="text-gray-400 hover:text-white p-2.5 shrink-0 rounded-full hover:bg-[#162236] transition-all border border-transparent hover:border-[#2A4A6B]/30 mr-1"

                                aria-label="Précédent"

                            >

                                <ChevronLeft size={20} />

                            </button>

                            

                            <div 

                                ref={dateSelectorRef}

                                className="flex-1 flex overflow-x-auto gap-2 py-3 scrollbar-custom"

                            >

                                {activeDates.map((d) => (

                                    <button

                                        key={d}

                                        onClick={() => setSelectedDate(d)}

                                        className={`px-5 py-2.5 rounded-lg text-sm font-heading font-semibold shrink-0 transition-all ${

                                            selectedDate === d

                                                ? "bg-[#1E3A5F] text-[#00C853] border border-[#00C853]/40"

                                                : "bg-[#162236]/50 text-gray-400 border border-transparent hover:text-white hover:bg-[#162236]"

                                        }`}

                                    >

                                        Journée {d}

                                    </button>

                                ))}

                            </div>



                            <button 

                                onClick={() => dateSelectorRef.current?.scrollBy({ left: 200, behavior: 'smooth' })}

                                className="text-gray-400 hover:text-white p-2.5 shrink-0 rounded-full hover:bg-[#162236] transition-all border border-transparent hover:border-[#2A4A6B]/30 ml-1"

                                aria-label="Suivant"

                            >

                                <ChevronRight size={20} />

                            </button>

                        </div>

                    )}



                    {/* LISTE DES MATCHS CENTRÉE */}

                    <div className="max-w-2xl mx-auto space-y-4">

                            {filteredMatches.length === 0 ? (

                                <div className="card-elev p-12 text-center text-gray-400 border-dashed">

                                    <Calendar className="mx-auto text-gray-600 mb-3" size={40} />

                                    <p className="text-sm font-medium">

                                        Les pronostics pour cette étape ne sont pas encore ouverts.

                                    </p>

                                    <p className="text-xs text-gray-500 mt-1">

                                        Revenez 72 heures avant le début de cette phase.

                                    </p>

                                </div>

                            ) : (

                                filteredMatches.map((m) => {

                                    const isSelected = selectedMatch?.id === m.id;

                                    const prono = predictions[m.id];

                                    const cd = getCountdown(m.kickoff);

                                    

                                    return (

                                        <div

                                            key={m.id}

                                            className={`card-elev p-5 transition-all duration-300 block ${

                                                isSelected 

                                                    ? "border-[#00C853] shadow-[0_4px_20px_rgba(0,200,83,0.1)] bg-[#1A2E44]"

                                                    : "hover:border-[#2A4A6B] bg-[#162236]"

                                            }`}

                                            data-testid={`match-card-${m.id}`}

                                        >

                                            {/* Match Card Header */}

                                            <div className="flex justify-between items-center text-xs text-gray-400 mb-4 pb-2 border-b border-[#2A4A6B]/30">

                                                <div className="font-semibold uppercase tracking-wider text-[#00C853]/90">

                                                    {selectedStage === "groups" ? `${m.group} · ` : ""}{selectedDate} {m.time}

                                                </div>

                                                <div className="flex items-center gap-1.5">
                                                    {m.video_url && (
                                                        <span className="inline-flex items-center gap-0.5 bg-red-600/10 border border-red-600/30 text-red-500 px-1.5 py-0.5 rounded text-[8px] font-black uppercase tracking-wider animate-pulse">
                                                            <Play size={8} className="fill-red-500 text-red-500" /> Vidéo
                                                        </span>
                                                    )}
                                                    <div className="inline-flex items-center gap-1 bg-[#1E3A5F] px-2 py-0.5 rounded text-[10px] font-bold text-white uppercase tracking-wider">

                                                        {m.status}

                                                    </div>
                                                </div>

                                            </div>



                                            {/* Teams VS Flags */}

                                            <div className="flex items-center justify-between gap-4 mb-5">

                                                <div className="flex-1 flex flex-col items-center text-center">

                                                    <img 

                                                        src={m.teamA.flag} 

                                                        alt={m.teamA.name} 

                                                        loading="lazy"

                                                        className="w-14 h-10 object-cover rounded shadow-md border border-[#2A4A6B]/50" 

                                                    />

                                                    <span className="font-heading font-extrabold text-white text-sm mt-2 line-clamp-1">

                                                        {m.teamA.name}

                                                    </span>

                                                </div>



                                                {m.scoreA !== null && m.scoreB !== null ? (

                                                    <div className="flex flex-col items-center">

                                                        <div className="font-heading font-black text-white text-3xl">

                                                            {m.scoreA} - {m.scoreB}

                                                        </div>

                                                        {m.pensA !== undefined && m.pensB !== undefined && (

                                                            <div className="text-[10px] text-gray-400 font-mono mt-0.5">

                                                                ({m.pensA} - {m.pensB} tab)

                                                            </div>

                                                        )}

                                                    </div>

                                                ) : (

                                                    <div className="font-heading font-black text-gray-500 italic text-2xl">

                                                        VS

                                                    </div>

                                                )}



                                                <div className="flex-1 flex flex-col items-center text-center">

                                                    <img 

                                                        src={m.teamB.flag} 

                                                        alt={m.teamB.name} 

                                                        loading="lazy"

                                                        className="w-14 h-10 object-cover rounded shadow-md border border-[#2A4A6B]/50" 

                                                    />

                                                    <span className="font-heading font-extrabold text-white text-sm mt-2 line-clamp-1">

                                                        {m.teamB.name}

                                                    </span>

                                                </div>

                                            </div>



                                            {/* Predict buttons */}

                                            <div className="grid grid-cols-3 gap-2 mb-4" onClick={(e) => e.stopPropagation()}>

                                                <button

                                                    onClick={(e) => { e.preventDefault(); handlePredict(m.id, "1"); }}

                                                    disabled={cd.finished}

                                                    className={`py-2 px-3 rounded-lg text-xs font-bold font-heading transition-all ${

                                                        prono === "1"

                                                            ? "bg-[#00C853] text-[#000000] font-black"

                                                            : `bg-[#0D1B2A] text-gray-300 border border-[#2A4A6B] ${!cd.finished ? "hover:border-[#00C853]" : ""}`

                                                    } ${cd.finished ? "opacity-60 cursor-not-allowed" : ""}`}

                                                >

                                                    {m.teamA.code} G.

                                                </button>

                                                <button

                                                    onClick={(e) => { e.preventDefault(); handlePredict(m.id, "N"); }}

                                                    disabled={cd.finished}

                                                    className={`py-2 px-3 rounded-lg text-xs font-bold font-heading transition-all ${

                                                        prono === "N"

                                                            ? "bg-[#00C853] text-[#000000] font-black"

                                                            : `bg-[#0D1B2A] text-gray-300 border border-[#2A4A6B] ${!cd.finished ? "hover:border-[#00C853]" : ""}`

                                                    } ${cd.finished ? "opacity-60 cursor-not-allowed" : ""}`}

                                                >

                                                    Match Nul

                                                </button>

                                                <button

                                                    onClick={(e) => { e.preventDefault(); handlePredict(m.id, "2"); }}

                                                    disabled={cd.finished}

                                                    className={`py-2 px-3 rounded-lg text-xs font-bold font-heading transition-all ${

                                                        prono === "2"

                                                            ? "bg-[#00C853] text-[#000000] font-black"

                                                            : `bg-[#0D1B2A] text-gray-300 border border-[#2A4A6B] ${!cd.finished ? "hover:border-[#00C853]" : ""}`

                                                    } ${cd.finished ? "opacity-60 cursor-not-allowed" : ""}`}

                                                >

                                                    {m.teamB.code} G.

                                                </button>

                                            </div>



                                            {/* Prediction Feedback */}

                                            {prono && m.scoreA !== null && m.scoreB !== null && (

                                                <div className="mt-3 mb-2 flex justify-center" onClick={(e) => e.stopPropagation()}>

                                                    {(() => {

                                                        const actualResult = m.scoreA > m.scoreB ? "1" : m.scoreA < m.scoreB ? "2" : "N";

                                                        const isCorrect = prono === actualResult;

                                                        return (

                                                            <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold ${

                                                                isCorrect 

                                                                    ? "bg-[#00C853]/15 text-[#00C853] border border-[#00C853]/30" 

                                                                    : "bg-[#D83C3C]/15 text-[#D83C3C] border border-[#D83C3C]/30"

                                                            }`}>

                                                                {isCorrect ? "Correct ✅" : "Incorrect ❌"} (Prono: {

                                                                    prono === "1" ? m.teamA.code : prono === "2" ? m.teamB.code : "Nul"

                                                                })

                                                            </span>

                                                        );

                                                    })()}

                                                </div>

                                            )}



                                            {/* Card Footer Countdown */}

                                            {!cd.finished && (

                                                <div className="flex justify-center items-center pt-3 border-t border-[#2A4A6B]/20 text-[11px] text-gray-400">

                                                    <div className="flex items-center gap-1 text-[#FFB300] font-mono font-bold">

                                                        <Clock size={12} />

                                                        <span>

                                                            {`${String(cd.days).padStart(2, '0')}j : ${String(cd.hours).padStart(2, '0')}h : ${String(cd.minutes).padStart(2, '0')}m : ${String(cd.seconds).padStart(2, '0')}s`}

                                                        </span>

                                                    </div>

                                                </div>

                                            )}

                                        </div>

                                    );

                                })

                            )}

                        </div>
                    {/* NOTATION HORAIRES */}

                    <div className="mt-8 text-center text-xs text-gray-500 flex items-center justify-center gap-1.5">

                        <span>⏰</span>

                        <span>Horaires Selon L'heure De Votre Appareil</span>

                    </div>

                </div>

            )}



            {/* ONGLET 2: CALENDRIER COMPLET & CLASSEMENTS (GROUPES) */}

            {activeTab === "standings" && (

                <div className="container-x py-10 animate-fade-in space-y-8">

                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">

                        {groups2026.map((g) => {

                            const groupStandings = computedStandings[g.key] || [];

                            return (

                                <div key={g.key} className="card-elev p-5 bg-[#162236]/90 border border-[#2A4A6B]/50 hover:border-[#00C853]/50 transition-all rounded-xl shadow-lg">

                                    <div className="flex justify-between items-center mb-4 pb-2 border-b border-[#2A4A6B]/30">

                                        <h3 className="font-heading font-extrabold text-lg text-white flex items-center gap-2">

                                            <Trophy className="text-[#00C853]" size={18} />

                                            {g.name}

                                        </h3>

                                        <span className="text-[10px] uppercase font-bold tracking-wider px-2 py-0.5 rounded bg-[#1E3A5F] text-white">

                                            Officiel

                                        </span>

                                    </div>

                                    <div className="overflow-x-auto">

                                        <table className="w-full text-left border-collapse text-xs">

                                            <thead>

                                                <tr className="text-gray-400 border-b border-[#2A4A6B]/20">

                                                    <th className="py-2 font-bold">Équipe</th>

                                                    <th className="py-2 text-center font-bold">J</th>

                                                    <th className="py-2 text-center font-bold">Diff</th>

                                                    <th className="py-2 text-right font-bold">Pts</th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {groupStandings.map((team, idx) => {

                                                    const isQualified = idx < 2; // Top 2 qualify

                                                    return (

                                                        <tr 

                                                            key={team.code} 

                                                            className={`border-b border-[#2A4A6B]/10 hover:bg-[#1E3A5F]/20 transition-colors ${

                                                                isQualified ? "text-white" : "text-gray-400"

                                                            }`}

                                                        >

                                                            <td className="py-2.5 flex items-center gap-2">

                                                                <span className="w-4 text-center font-mono font-bold text-gray-500 text-[10px]">

                                                                    {idx + 1}

                                                                </span>

                                                                <img 

                                                                    src={team.flag} 

                                                                    alt={team.name}

                                                                    loading="lazy" 

                                                                    className="w-6 h-4 object-cover rounded shadow border border-[#2A4A6B]/20" 

                                                                />

                                                                <span className="font-semibold truncate max-w-[120px]">

                                                                    {team.name}

                                                                </span>

                                                            </td>

                                                            <td className="py-2.5 text-center font-mono">{team.p}</td>

                                                            <td className={`py-2.5 text-center font-mono font-semibold ${

                                                                team.gd > 0 ? "text-[#00C853]" : team.gd < 0 ? "text-[#D83C3C]" : "text-gray-400"

                                                            }`}>

                                                                {team.gd > 0 ? `+${team.gd}` : team.gd}

                                                            </td>

                                                            <td className={`py-2.5 text-right font-bold font-mono ${

                                                                isQualified ? "text-[#00C853] text-sm" : ""

                                                            }`}>

                                                                {team.pts}

                                                            </td>

                                                        </tr>

                                                    );

                                                })}

                                            </tbody>

                                        </table>

                                    </div>

                                </div>

                            );

                        })}

                    </div>

                </div>

            )}



            {/* ONGLET 3: TABLEAU FINAL (BRACKET) */}

            {activeTab === "bracket" && (

                <div className="container-x py-10 animate-fade-in overflow-x-auto scrollbar-thin">

                    {/* Toggles As it stands / Confirmed */}

                    <div className="flex items-center justify-center gap-3 mb-8">

                        <button

                            onClick={() => setBracketFilter("as_it_stands")}

                            className={`px-4 py-1.5 rounded-full text-xs font-bold transition-all ${

                                bracketFilter === "as_it_stands"

                                    ? "bg-white text-[#0D1B2A] shadow"

                                    : "bg-[#162236] text-gray-400 border border-[#2A4A6B]/30 hover:border-white/20"

                            }`}

                        >

                            As it stands

                        </button>

                        <button

                            onClick={() => setBracketFilter("confirmed")}

                            className={`px-4 py-1.5 rounded-full text-xs font-bold transition-all ${

                                bracketFilter === "confirmed"

                                    ? "bg-white text-[#0D1B2A] shadow"

                                    : "bg-[#162236] text-gray-400 border border-[#2A4A6B]/30 hover:border-white/20"

                            }`}

                        >

                            Confirmed

                        </button>

                    </div>



                    {/* EN-TÊTES DE COLONNES ALIGNÉES */}

                    <div className="flex justify-between items-center gap-12 min-w-[1450px] border-b border-[#2A4A6B]/30 pb-3 mb-6 select-none">

                        <div className="flex gap-12">

                            <div className="w-44 text-center font-heading font-black text-[10px] uppercase tracking-widest text-gray-400">16es de finale</div>

                            <div className="w-44 text-center font-heading font-black text-[10px] uppercase tracking-widest text-gray-400">8es de finale</div>

                            <div className="w-44 text-center font-heading font-black text-[10px] uppercase tracking-widest text-gray-400">Quarts de finale</div>

                            <div className="w-44 text-center font-heading font-black text-[10px] uppercase tracking-widest text-gray-400">Demi-finales</div>

                        </div>

                        <div className="w-60 text-center font-heading font-black text-[10px] uppercase tracking-widest text-gray-400">Finale</div>

                        <div className="flex gap-12">

                            <div className="w-44 text-center font-heading font-black text-[10px] uppercase tracking-widest text-gray-400">Demi-finales</div>

                            <div className="w-44 text-center font-heading font-black text-[10px] uppercase tracking-widest text-gray-400">Quarts de finale</div>

                            <div className="w-44 text-center font-heading font-black text-[10px] uppercase tracking-widest text-gray-400">8es de finale</div>

                            <div className="w-44 text-center font-heading font-black text-[10px] uppercase tracking-widest text-gray-400">16es de finale</div>

                        </div>

                    </div>



                    <div className="flex justify-between items-stretch gap-12 min-w-[1450px] pb-6">

                        

                        {/* GAUCHE: 16es, 8es, Quarts, Demi */}

                        <div className="flex gap-12">

                            {/* Column 1: 16es (8 matches) */}

                            <div className="flex flex-col gap-6 w-44">

                                {/* Pair 1 */}

                                <div className="relative h-[204px] flex flex-col justify-between">

                                    {renderBracketMatch(matches.find(x => x.id === "16e-1"))}

                                    {renderBracketMatch(matches.find(x => x.id === "16e-2"))}

                                    {/* Connector */}

                                    <div className="absolute right-[-24px] top-[45px] bottom-[45px] w-[24px] border-r border-t border-b border-[#2A4A6B]/60 rounded-r">

                                        <div className="absolute right-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                                {/* Pair 2 */}

                                <div className="relative h-[204px] flex flex-col justify-between">

                                    {renderBracketMatch(matches.find(x => x.id === "16e-3"))}

                                    {renderBracketMatch(matches.find(x => x.id === "16e-4"))}

                                    {/* Connector */}

                                    <div className="absolute right-[-24px] top-[45px] bottom-[45px] w-[24px] border-r border-t border-b border-[#2A4A6B]/60 rounded-r">

                                        <div className="absolute right-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                                {/* Pair 3 */}

                                <div className="relative h-[204px] flex flex-col justify-between">

                                    {renderBracketMatch(matches.find(x => x.id === "16e-5"))}

                                    {renderBracketMatch(matches.find(x => x.id === "16e-6"))}

                                    {/* Connector */}

                                    <div className="absolute right-[-24px] top-[45px] bottom-[45px] w-[24px] border-r border-t border-b border-[#2A4A6B]/60 rounded-r">

                                        <div className="absolute right-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                                {/* Pair 4 */}

                                <div className="relative h-[204px] flex flex-col justify-between">

                                    {renderBracketMatch(matches.find(x => x.id === "16e-7"))}

                                    {renderBracketMatch(matches.find(x => x.id === "16e-8"))}

                                    {/* Connector */}

                                    <div className="absolute right-[-24px] top-[45px] bottom-[45px] w-[24px] border-r border-t border-b border-[#2A4A6B]/60 rounded-r">

                                        <div className="absolute right-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                            </div>



                            {/* Column 2: 8es (4 matches) */}

                            <div className="flex flex-col gap-6 w-44">

                                <div className="relative h-[204px] flex items-center">

                                    {renderBracketMatch(matches.find(x => x.id === "8e-1"))}

                                </div>

                                <div className="relative h-[204px] flex items-center">

                                    {renderBracketMatch(matches.find(x => x.id === "8e-2"))}

                                    {/* Connector */}

                                    <div className="absolute right-[-24px] top-[-126px] h-[228px] w-[24px] border-r border-t border-b border-[#2A4A6B]/60 rounded-r">

                                        <div className="absolute right-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                                <div className="relative h-[204px] flex items-center">

                                    {renderBracketMatch(matches.find(x => x.id === "8e-3"))}

                                </div>

                                <div className="relative h-[204px] flex items-center">

                                    {renderBracketMatch(matches.find(x => x.id === "8e-4"))}

                                    {/* Connector */}

                                    <div className="absolute right-[-24px] top-[-126px] h-[228px] w-[24px] border-r border-t border-b border-[#2A4A6B]/60 rounded-r">

                                        <div className="absolute right-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                            </div>



                            {/* Column 3: Quarts (2 matches) */}

                            <div className="flex flex-col gap-6 w-44">

                                <div className="relative h-[432px] flex items-center">

                                    {renderBracketMatch(matches.find(x => x.id === "qf-1"))}

                                </div>

                                <div className="relative h-[432px] flex items-center">

                                    {renderBracketMatch(matches.find(x => x.id === "qf-2"))}

                                    {/* Connector */}

                                    <div className="absolute right-[-24px] top-[-240px] h-[456px] w-[24px] border-r border-t border-b border-[#2A4A6B]/60 rounded-r">

                                        <div className="absolute right-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                            </div>



                            {/* Column 4: Demi (1 match) */}

                            <div className="flex flex-col gap-6 w-44">

                                <div className="relative h-[888px] flex items-center">

                                    {renderBracketMatch(matches.find(x => x.id === "df-1"))}

                                    {/* Line to Finale */}

                                    <div className="absolute right-[-48px] top-[50%] -translate-y-1/2 w-[48px] border-t border-[#2A4A6B]/60"></div>

                                </div>

                            </div>

                        </div>



                        {/* CENTRE: TROPHÉE ET FINALES */}

                        <div className="flex flex-col items-center justify-center gap-8 w-60 px-4 shrink-0 min-h-[888px]">

                            <div className="flex flex-col items-center select-none">

                                <div className="p-4 bg-[#FFB300]/10 border border-[#FFB300]/30 rounded-xl text-[#FFB300] mb-2 shadow-[0_0_20px_rgba(255,179,0,0.12)]">

                                    <Trophy size={44} className="animate-pulse" />

                                </div>

                                <span className="font-heading font-black text-[10px] uppercase tracking-widest text-[#FFB300]">

                                    CHAMPION

                                </span>

                            </div>



                            {/* Finale match box */}

                            <div className="w-full">

                                <div className="text-center font-heading font-black text-[10px] uppercase tracking-widest text-gray-400 border-b border-[#2A4A6B]/50 pb-2 mb-3">

                                    Finale

                                </div>

                                {matches.filter(m => m.id === "final").map(m => renderBracketMatch(m, true))}

                            </div>



                            {/* Petite Finale */}

                            <div className="w-full">

                                <div className="text-center font-heading font-black text-[9px] uppercase tracking-widest text-gray-500 border-b border-[#2A4A6B]/30 pb-2 mb-3">

                                    Petite Finale (3e place)

                                </div>

                                {matches.filter(m => m.id === "third-place").map(m => renderBracketMatch(m, false))}

                            </div>

                        </div>



                        {/* DROITE: Demi, Quarts, 8es, 16es */}

                        <div className="flex gap-12">

                            {/* Column 4: Demi (1 match) */}

                            <div className="flex flex-col gap-6 w-44">

                                <div className="relative h-[888px] flex items-center">

                                    {/* Line to Finale */}

                                    <div className="absolute left-[-48px] top-[50%] -translate-y-1/2 w-[48px] border-t border-[#2A4A6B]/60"></div>

                                    {renderBracketMatch(matches.find(x => x.id === "df-2"))}

                                </div>

                            </div>



                            {/* Column 3: Quarts (2 matches) */}

                            <div className="flex flex-col gap-6 w-44">

                                <div className="relative h-[432px] flex items-center">

                                    {renderBracketMatch(matches.find(x => x.id === "qf-3"))}

                                </div>

                                <div className="relative h-[432px] flex items-center">

                                    {/* Connector */}

                                    <div className="absolute left-[-24px] top-[-240px] h-[456px] w-[24px] border-l border-t border-b border-[#2A4A6B]/60 rounded-l">

                                        <div className="absolute left-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                    {renderBracketMatch(matches.find(x => x.id === "qf-4"))}

                                </div>

                            </div>



                            {/* Column 2: 8es (4 matches) */}

                            <div className="flex flex-col gap-6 w-44">

                                <div className="relative h-[204px] flex items-center">

                                    {renderBracketMatch(matches.find(x => x.id === "8e-5"))}

                                </div>

                                <div className="relative h-[204px] flex items-center">

                                    {/* Connector */}

                                    <div className="absolute left-[-24px] top-[-126px] h-[228px] w-[24px] border-l border-t border-b border-[#2A4A6B]/60 rounded-l">

                                        <div className="absolute left-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                    {renderBracketMatch(matches.find(x => x.id === "8e-6"))}

                                </div>

                                <div className="relative h-[204px] flex items-center">

                                    {renderBracketMatch(matches.find(x => x.id === "8e-7"))}

                                </div>

                                <div className="relative h-[204px] flex items-center">

                                    {/* Connector */}

                                    <div className="absolute left-[-24px] top-[-126px] h-[228px] w-[24px] border-l border-t border-b border-[#2A4A6B]/60 rounded-l">

                                        <div className="absolute left-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                    {renderBracketMatch(matches.find(x => x.id === "8e-8"))}

                                </div>

                            </div>



                            {/* Column 1: 16es (8 matches) */}

                            <div className="flex flex-col gap-6 w-44">

                                {/* Pair 1 */}

                                <div className="relative h-[204px] flex flex-col justify-between">

                                    {renderBracketMatch(matches.find(x => x.id === "16e-9"))}

                                    {renderBracketMatch(matches.find(x => x.id === "16e-10"))}

                                    {/* Connector */}

                                    <div className="absolute left-[-24px] top-[45px] bottom-[45px] w-[24px] border-l border-t border-b border-[#2A4A6B]/60 rounded-l">

                                        <div className="absolute left-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                                {/* Pair 2 */}

                                <div className="relative h-[204px] flex flex-col justify-between">

                                    {renderBracketMatch(matches.find(x => x.id === "16e-11"))}

                                    {renderBracketMatch(matches.find(x => x.id === "16e-12"))}

                                    {/* Connector */}

                                    <div className="absolute left-[-24px] top-[45px] bottom-[45px] w-[24px] border-l border-t border-b border-[#2A4A6B]/60 rounded-l">

                                        <div className="absolute left-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                                {/* Pair 3 */}

                                <div className="relative h-[204px] flex flex-col justify-between">

                                    {renderBracketMatch(matches.find(x => x.id === "16e-13"))}

                                    {renderBracketMatch(matches.find(x => x.id === "16e-14"))}

                                    {/* Connector */}

                                    <div className="absolute left-[-24px] top-[45px] bottom-[45px] w-[24px] border-l border-t border-b border-[#2A4A6B]/60 rounded-l">

                                        <div className="absolute left-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                                {/* Pair 4 */}

                                <div className="relative h-[204px] flex flex-col justify-between">

                                    {renderBracketMatch(matches.find(x => x.id === "16e-15"))}

                                    {renderBracketMatch(matches.find(x => x.id === "16e-16"))}

                                    {/* Connector */}

                                    <div className="absolute left-[-24px] top-[45px] bottom-[45px] w-[24px] border-l border-t border-b border-[#2A4A6B]/60 rounded-l">

                                        <div className="absolute left-[-24px] top-[50%] -translate-y-1/2 w-[24px] border-t border-[#2A4A6B]/60"></div>

                                    </div>

                                </div>

                            </div>

                        </div>



                    </div>

                </div>

            )}



            {/* ONGLET 4: SIMULATEUR IA */}

            {activeTab === "simulator" && (

                <div className="container-x py-10 animate-fade-in space-y-6">

                    <SimulationControls 

                        state={simState}

                        onRun={runSimulation}

                        onReset={resetSimulation}

                    />



                    {simState.status === "error" && (

                        <div className="card-elev p-5 border border-red-500/50 bg-red-500/10 text-red-200 text-sm">

                            Une erreur est survenue lors de la simulation : {simState.error}

                        </div>

                    )}



                    {simState.status === "running" && (

                        <div className="card-elev p-8 text-center text-gray-400 text-sm border border-[#2A4A6B] flex flex-col items-center justify-center gap-4">

                            <RefreshCw className="h-8 w-8 animate-spin text-[#00C853]" />

                            <div>

                                <p className="font-semibold text-white">Simulation en cours...</p>

                                <p className="text-xs text-gray-500 mt-1">Veuillez patienter pendant le calcul des probabilités Monte Carlo.</p>

                            </div>

                        </div>

                    )}



                    {simState.status === "done" && simState.result && (

                        <div className="space-y-8 animate-fadeIn">

                            <ValueBetsFinder result={simState.result} />

                            

                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">

                                <ChampionProbBar 

                                    result={simState.result} 

                                    resultNoAbsences={simState.resultNoAbsences} 

                                />

                                <PredictionDelta result={simState.result} />

                            </div>



                            <StageMatrix result={simState.result} />



                            <BracketTree result={simState.result} />

                        </div>

                    )}



                    {simState.status === "idle" && (

                        <div className="card-elev p-12 text-center text-gray-400 border border-dashed border-[#2A4A6B]">

                            <Sparkles className="mx-auto text-gray-600 mb-3 animate-pulse" size={40} />

                            <p className="text-sm font-medium text-white">

                                Simulateur Prédictif Monte Carlo IA

                            </p>

                            <p className="text-xs text-gray-500 mt-2 max-w-md mx-auto">

                                Configurez vos hypothèses de force d'équipe (ELO) ou de blessures dans le bac à sable, puis lancez les simulations pour analyser les scénarios les plus probables de la Coupe du Monde 2026.

                            </p>

                        </div>

                    )}

                </div>

            )}

        </div>

    );

};



export default CoupeDuMonde;

